const _fc_props = {};
_fc_props.ante_meridiem = 'сутринта';
_fc_props.post_meridiem = 'вечер';
_fc_props.retry = 'Опитай отново';
_fc_props.default = 'По подразбиране';
_fc_props.origin = 'Произход';
_fc_props.day = 'Ден';
_fc_props.loading = 'Зареждане';
_fc_props.list = 'Списък';
_fc_props.error = 'Грешка';
_fc_props.save = 'Запазване';
_fc_props.delete = 'Изтриване';
_fc_props.message = 'Съобщение';
_fc_props.logout = 'Изход';
_fc_props.add = 'Добавяне';
_fc_props.remove = 'Премахване';
_fc_props.done = 'Готово';
_fc_props.other = 'Друго';
_fc_props.interval = 'Интервал';
_fc_props.time = 'Време';
_fc_props.speed = 'Скорост';
_fc_props.longitude = 'Географска дължина';
_fc_props.latitude = 'Географска ширина';
_fc_props.x_minutes = '{0} мин.';
_fc_props.errors = 'Грешки';
_fc_props.general = 'Общи';
_fc_props.messages = 'Съобщения';
_fc_props.gps_fixes = 'GPS корекции';
_fc_props.device_id = 'Идентификатор на устройството';
_fc_props.vehicle = 'Превозно средство';
_fc_props.employee = 'Служител';
_fc_props.version = 'Версия';
_fc_props.statuses = 'Статуси';
_fc_props.edit = 'Редактиране';
_fc_props.cancel = 'Отказ';
_fc_props.yes = 'Да';
_fc_props.none = 'Няма';
_fc_props.item = 'Елемент';
_fc_props.never = 'Никога';
_fc_props.name = 'Име';
_fc_props.average = 'Средно';
_fc_props.items = 'Елементи';
_fc_props.true = 'Вярно';
_fc_props.status = 'Статус';
_fc_props.distance = 'Разстояние';
_fc_props.ok = 'Добре';
_fc_props.login = 'Вход';
_fc_props.next = 'Следващо';
_fc_props.info = 'Информация';
_fc_props.menu = 'Меню';
_fc_props.not_available = 'Няма данни';
_fc_props.back = 'Обратно';
_fc_props.refresh = 'Опресняване';
_fc_props.select = 'Изберете';
_fc_props.dispatch = 'Изпращане';
_fc_props.messaging = 'Съобщения';
_fc_props.plants = 'Растения';
_fc_props.last_plants = 'Последни растения';
_fc_props.vehicle_types = 'Видове превозни средства';
_fc_props.employee_types = 'Видове служители';
_fc_props.employee_groups = 'Групи служители';
_fc_props.equipment_groups = 'Групи оборудване';
_fc_props.status_type = 'Тип състояние';
_fc_props.job = 'Работа';
_fc_props.order = 'Поръчка';
_fc_props.ticket = 'Номер на билет';
_fc_props.small = 'Малък';
_fc_props.medium = 'Среден';
_fc_props.large = 'Голям';
_fc_props.reports = 'Доклади';
_fc_props.payroll = 'Заплати';
_fc_props.support = 'Поддръжка';
_fc_props.username = 'Потребителско име';
_fc_props.all = 'Всички';
_fc_props.question = 'Въпрос';
_fc_props.select_employee = 'Изберете служител';
_fc_props.phone = 'Телефон';
_fc_props.january = 'януари';
_fc_props.february = 'февруари';
_fc_props.march = 'март';
_fc_props.april = 'Април';
_fc_props.may = 'Май';
_fc_props.june = 'юни';
_fc_props.july = 'юли';
_fc_props.august = 'август';
_fc_props.september = 'Септември';
_fc_props.october = 'октомври';
_fc_props.november = 'ноември';
_fc_props.december = 'Декември';
_fc_props.are_you_sure_you_want_to_delete = 'Сигурни ли сте, че искате да изтриете';
_fc_props.unknown = 'Неизвестен';
_fc_props.invalid_date_range_report_is_limited_to_x_days = 'Невалиден диапазон от дати: Отчетът е ограничен до {0} дни';
_fc_props.select_all = 'Избери всички';
_fc_props.resolution = 'Резолюция';
_fc_props.equipment = 'Оборудване';
_fc_props.totals = 'Общо';
_fc_props.region = 'Регион';
_fc_props.no_data = 'Няма данни';
_fc_props.hotspot = 'Гореща точка';
_fc_props.hotspot_type = 'Тип гореща точка';
_fc_props.datetime = 'Дата/час';
_fc_props.address = 'Адрес';
_fc_props.retrieving_address = 'Извличане на адрес...';
_fc_props.address_not_found = 'Адресът не е намерен';
_fc_props.active_time = 'Активно време';
_fc_props.destination_time = 'Време на дестинацията';
_fc_props.complete_time = 'Пълно време';
_fc_props.status_report = 'Отчет за състоянието';
_fc_props.export_report = 'Експортиране на отчет';
_fc_props.download_report = 'Изтегляне на отчета';
_fc_props.view_report = 'Преглед на отчета';
_fc_props.duration = 'Продължителност';
_fc_props.min = 'Мин.';
_fc_props.start_date_time = 'Начална дата/час';
_fc_props.select_start_date = 'Изберете начална дата';
_fc_props.end_date_time = 'Крайна дата/час';
_fc_props.select_end_date = 'Изберете крайна дата';
_fc_props.trip_time = 'Време за пътуване';
_fc_props.travel_time = 'Време за пътуване';
_fc_props.description = 'Описание';
_fc_props.map_controls = 'Контроли на картата';
_fc_props.road = 'Път';
_fc_props.aerial = 'Въздушна';
_fc_props.hybrid = 'Хибрид';
_fc_props.trip = 'Пътуване';
_fc_props.map = 'Карта';
_fc_props.plant = 'Растение';
_fc_props.select_date = 'Изберете дата';
_fc_props.apply = 'Приложи';
_fc_props.save_settings = 'Запазване на настройките';
_fc_props.false = 'Фалшиво';
_fc_props.delete_confirmation = 'Потвърждение за изтриване';
_fc_props.last_name = 'Фамилия';
_fc_props.none_selected = 'Няма избрано';
_fc_props.start_date = 'Начална дата';
_fc_props.group_by = 'Групиране по';
_fc_props.equipment_employee = 'Оборудване / Служител';
_fc_props.inactive = 'Неактивен';
_fc_props.active = 'Активен';
_fc_props.note_checking_may_affect_performance = 'Забележка: Проверката може да повлияе на производителността';
_fc_props.show_distancefuel_used = 'Показване на разстояние/използвано гориво';
_fc_props.mins = 'Мин.';
_fc_props.threshold_time = 'Прагово време';
_fc_props.include_voided_tickets = 'Включи анулирани билети';
_fc_props.note_all_times_listed_are_in_minutes = 'Забележка: Всички посочени времена са в минути';
_fc_props.please_select_a_job_order_or_equipment = 'Моля, изберете работа, поръчка, инсталация, оборудване или служител';
_fc_props.device = 'Устройство';
_fc_props.select_equipment = 'Изберете оборудване';
_fc_props.on_enter = 'При влизане';
_fc_props.on_exit = 'На изход';
_fc_props.all_equipment_types = 'Всички видове оборудване';
_fc_props.summary = 'Обобщение';
_fc_props.units = {};
_fc_props.units.liters = 'Литри';
_fc_props.type = 'Тип';
_fc_props.no_data_available = 'Няма налични данни';
_fc_props.menu = {};
_fc_props.menu.reports = {};
_fc_props.menu.reports.title = {};
_fc_props.menu.reports.title.breakdown = 'Разбивка';
_fc_props.menu.reports.title.distance_and_fuel_by_region = 'Разстояние и гориво по регион';
_fc_props.menu_settings_title_settings = 'Настройки';
_fc_props.menu_settings_title_alerts = 'Сигнали';
_fc_props.menu.settings = {};
_fc_props.menu.settings.title = {};
_fc_props.menu.settings.title.equipment = 'Оборудване';
_fc_props.menu_settings_title_hotspots_regions = 'Горещи точки и региони';
_fc_props.days = '{0} ден(а)';
_fc_props.home = 'Дом';
_fc_props.find = 'Намерете';
_fc_props.close_this_panel = 'затвори този панел';
_fc_props.filters = 'Филтри';
_fc_props.start = 'Старт';
_fc_props.end = 'Край';
_fc_props.location_details = 'Детайли за местоположението';
_fc_props.first_name = 'Собствено име';
_fc_props.material_per_hour = 'Материал на час';
_fc_props.equipment_pound = 'Оборудване #';
_fc_props.equipment_type = 'Тип оборудване';
_fc_props.options = 'Опции';
_fc_props.zoom_on_cursor_position = 'Мащабиране на позицията на курсора';
_fc_props.display_equipment_identifier = 'Идентификатор на оборудване за показване';
_fc_props.view_equipment = 'Преглед на оборудването';
_fc_props.view_hotspots = 'Преглед на горещи точки';
_fc_props.view_regions = 'Преглед на регионите';
_fc_props.use_standard_filters = 'Използвайте стандартни филтри';
_fc_props.home_plant = 'Домашно растение';
_fc_props.last_plant = 'Последно растение';
_fc_props.equip_types = 'Видове оборудване';
_fc_props.equip_groups = 'Оборудване. Групи';
_fc_props.orders = 'Поръчки';
_fc_props.trakitall = 'TrakitALL';
_fc_props.use_equipment_filter = 'Използвайте филтър за оборудване';
_fc_props.all_selected = 'Всички избрани';
_fc_props.of = 'От';
_fc_props.your_map_session_has_expired = 'Вашата сесия с картата е изтекла. Моля, обновете страницата.';
_fc_props.equipment_short = 'Оборудвайте.';
_fc_props.job_info_for = 'Информация за работата за';
_fc_props.order_info_for = 'Информация за поръчката за';
_fc_props.ticket_info_for_vehicle = 'Информация за билета за превозно средство';
_fc_props.inbox = 'Входяща поща';
_fc_props.outbox = 'Изходяща поща';
_fc_props.alerts = 'Сигнали';
_fc_props.critical = 'Критично';
_fc_props.important = 'Важно';
_fc_props.informational = 'Информационен';
_fc_props.customer = 'Клиент';
_fc_props.view_routes = 'Преглед на маршрути';
_fc_props.hours_size = 'Размер на часовете';
_fc_props.used_count = 'Брой използвани';
_fc_props.last_login = 'Последно влизане';
_fc_props.last_vehicle = 'Последно превозно средство';
_fc_props.regions = 'Региони';
_fc_props.employee_type = 'Тип служител';
_fc_props.driver = 'Шофьор';
_fc_props.js_delete = 'Изтриване';
_fc_props.move = 'Преместване';
_fc_props.edit_hotspot = 'Редактиране на гореща точка';
_fc_props.adjust_shape = 'Коригиране на формата';
_fc_props.edit_region = 'Редактиране на регион';
_fc_props.enter_a_start_address = 'Моля, въведете начален адрес';
_fc_props.select_a_start_hotspot = 'Моля, изберете начална точка за достъп';
_fc_props.failed_to_find_start_hotspot = 'Неуспешно намиране на начална точка за достъп.';
_fc_props.invalid_latitudelongitude = 'Невалидна географска ширина/дължина';
_fc_props.enter_an_end_address = 'Моля, въведете краен адрес';
_fc_props.select_an_end_hotspot = 'Моля, изберете крайна точка за достъп';
_fc_props.failed_to_find_end_hotspot = 'Неуспешно намиране на крайната точка за достъп.';
_fc_props.print = 'Печат';
_fc_props.these_directions_are_for_informational_purposes = 'Тези указания са само с информационна цел. Не се дава гаранция за тяхната пълнота или точност. Строителни проекти, трафик или други събития могат да доведат до разлики в действителните условия от тези резултати.';
_fc_props.enter_an_address = 'Моля, въведете адрес';
_fc_props.select_a_hotspot = 'Моля, изберете гореща точка';
_fc_props.failed_to_find_hotspot = 'Неуспешно намиране на точка за достъп.';
_fc_props.select_a_vehicle = 'Моля, изберете превозно средство';
_fc_props.failed_to_find_vehicle = 'Неуспешно намиране на превозно средство.';
_fc_props.failed_to_find_address = 'Неуспешно намиране на адрес';
_fc_props.failed_to_find_vehicles = 'Неуспешно намиране на превозни средства по критериите за търсене.';
_fc_props.get_address = 'Получаване на адрес';
_fc_props.results_for = 'Резултати за';
_fc_props.error_retrieving_results = 'Грешка при извличане на резултатите';
_fc_props.no_results_found = 'Няма намерени резултати';
_fc_props.address_is_required = 'Адресът е задължителен';
_fc_props.city_is_required = 'Градът е задължително поле';
_fc_props.set_location = 'Задаване на местоположение';
_fc_props.set_area_of_interest = 'Задаване на област на интерес';
_fc_props.center_map_here = 'Центрирайте картата тук';
_fc_props.zoom_to_street_level = 'Мащабиране до нивото на улицата';
_fc_props.set_start = 'Задай старт';
_fc_props.set_end = 'Край на настройката';
_fc_props.delete_node = 'Изтриване на възел';
_fc_props.create_a_hotspot = 'Създаване на гореща точка';
_fc_props.create_a_region = 'Създаване на регион';
_fc_props.toggle_shapes = 'Превключване на форми';
_fc_props.refresh_map = 'Обновяване на картата';
_fc_props.more_options = 'Още опции';
_fc_props.recenter_map = 'Прецентриране на картата';
_fc_props.zoom_to_vehicle = 'Мащабиране на превозното средство';
_fc_props.apply_filters = 'Прилагане на филтри';
_fc_props.grid_view = 'Изглед в мрежа';
_fc_props.list_view = 'Списъчен изглед';
_fc_props.click_to_sort = 'Кликнете, за да сортирате';
_fc_props.message_history = 'История на съобщенията';
_fc_props.equipment_types = 'Видове оборудване';
_fc_props.send_message = 'Изпрати съобщение';
_fc_props.last_load = 'Последно зареждане';
_fc_props.last_load_on = 'Последно зареждане на';
_fc_props.manual_logout = 'Ръчно излизане';
_fc_props.manual_login = 'Ръчно влизане';
_fc_props.no_employees_logged_in = 'Няма влезли служители';
_fc_props.select_phone = 'Изберете телефон';
_fc_props.you_must_select_a_phone = 'Трябва да изберете телефон, оборудване и служител';
_fc_props.are_you_sure_you_want_to_logout = 'Сигурни ли сте, че искате да излезете?';
_fc_props.fix_time = 'Време за фиксиране';
_fc_props.to_next_fix = 'до следващото поправяне';
_fc_props.minutes_to_next_fix = 'Минути до следващата поправка';
_fc_props.liters = 'Литри';
_fc_props.destination = 'Дестинация';
_fc_props.return = 'Връщане';
_fc_props.product = 'Продукт';
_fc_props.no_records_found = 'Не са намерени записи.';
_fc_props.vehicle_type = 'Тип превозно средство';
_fc_props.view_in_map = 'Вижте всички на картата';
_fc_props.uploads = 'Качени файлове';
_fc_props.upload_csv_file = 'Качване на CSV файл';
_fc_props.permanent = 'Постоянен';
_fc_props.expire_time = 'Време на изтичане';
_fc_props.please_select_x_for_tickets_marked_active = 'Моля, изберете {0} за билети, маркирани като АКТИВНИ';
_fc_props.multiple_tickets_marked_active_for_same_x = 'Няколко билета, маркирани като АКТИВНИ за един и същ {0}';
_fc_props.delivery_time = 'Време за доставка';
_fc_props.failure_connecting_to_servlet = 'Грешка при свързване със сървлет.';
_fc_props.status_time_summary = 'Обобщение на времето за състояние';
_fc_props.view_in_map_one = 'Вижте на картата';
_fc_props.question_report = 'Доклад за въпроси';
_fc_props.end_date = 'Крайна дата';
_fc_props.trailer_number = 'Номер на ремаркето';
_fc_props.region_panel = 'Регионален панел';
_fc_props.hotspot_panel = 'Панел с горещи точки';
_fc_props.shape = 'Форма';
_fc_props.circle = 'Кръг';
_fc_props.polygon = 'Многоъгълник';
_fc_props.click_the_map_to_set_the_location = 'Кликнете върху картата, за да зададете желаното местоположение.';
_fc_props.click_the_map_to_set_the_hotspot_center = 'Щракнете върху картата, за да зададете центъра на горещата точка.';
_fc_props.click_the_map_to_set_the_region_center = 'Щракнете върху картата, за да зададете центъра на региона.';
_fc_props.click_and_drag_points = 'Щракнете и плъзнете точки, за да редактирате формата. Щракнете върху ЗАПАЗВАНЕ, за да запазите промените.';
_fc_props.size = 'Размер';
_fc_props.are_you_sure_you_want_to_move_this = 'Сигурни ли сте, че искате да преместите това';
_fc_props.are_you_sure_you_want_to_delete_this = 'Сигурни ли сте, че искате да изтриете това';
_fc_props.please_enter_a_valid_size = 'Моля, въведете валиден размер';
_fc_props.failed_to_save = 'Запазването не бе успешно.';
_fc_props.failed_to_move = 'Неуспешно преместване.';
_fc_props.failed_to_delete = 'Изтриването не бе успешно.';
_fc_props.x_hours = '{0} часа';
_fc_props.hide_hotspots = 'Скриване на горещи точки';
_fc_props.show_regions = 'Показване на региони';
_fc_props.show_hotspots = 'Показване на горещи точки';
_fc_props.hide_regions = 'Скриване на региони';
_fc_props.numeric = 'Числов';
_fc_props.message_type = 'Тип съобщение';
_fc_props.text = 'Текст';
_fc_props.yes_no = 'Да/Не';
_fc_props.responses = 'Отговори';
_fc_props.disabled = 'За хора с увреждания';
_fc_props.group_name = 'Име на групата';
_fc_props.start_timer = 'Стартиране на таймера';
_fc_props.stop_timer = 'Спиране на таймера';
_fc_props.are_you_sure_you_want_to_delete_the_x_format = 'Сигурни ли сте, че искате да изтриете формата „{0}“?';
_fc_props.phone_number = 'Телефонен номер';
_fc_props.interface_pound = 'Интерфейс #';
_fc_props.field = 'Поле';
_fc_props.default_label = 'Етикет по подразбиране';
_fc_props.custom_label = 'Персонализиран етикет';
_fc_props.you_must_enter_a_label = 'Трябва да въведете етикет.';
_fc_props.enabled = 'Активирано';
_fc_props.settings = {};
_fc_props.settings.ticket_integration = 'Интеграция на билети';
_fc_props.settings.geofence_off_open_hotspots = 'Геозониране извън отворени горещи точки';
_fc_props.settings.associate_open_hotspots_wticket = 'Свържете отворени горещи точки с билет';
_fc_props.settings.allow_geofencing_off_of_open_hotspots_or_only_hotspots_associated_with_drivers_ticket = 'Разрешаване на геозониране извън отворени горещи точки или само горещи точки, свързани с шофьорски билет';
_fc_props.settings.whether_or_not_to_associate_open_hotspots_with_tickets_when_a_vehicle_enters_them = 'Дали да се свързват отворени горещи точки с билети, когато превозно средство влезе в тях';
_fc_props.settings.void_ticket_without_destination = 'Невалиден билет без дестинация';
_fc_props.settings.if_a_ticket_is_received_while_another_one_is_active_if_the_active_ticket_does = 'Ако бъде получен билет, докато друг е активен, и ако активният билет няма дестинация, билетът ще бъде анулиран.';
_fc_props.settings.autocreate_hotspots = 'Автоматично създаване на горещи точки';
_fc_props.settings.whether_or_not_to_automatically_create_hotspots_from_the_destination = 'Дали да се създават автоматично горещи точки от адреса на местоназначението, когато бъде получен билет';
_fc_props.settings.autoactivate_ticket_upon_receive = 'Автоматично активиране на билета при получаване';
_fc_props.settings.is_the_ticket_active_when_it_is_received_by_trackit_default_true = 'Активен ли е билетът, когато бъде получен от TrackIt (по подразбиране „true“)';
_fc_props.settings.auto_close_active_ticket_upon_receive_minutes = 'Автоматично затваряне на активен билет при получаване на минути';
_fc_props.settings.how_long_does_the_current_active_ticket_need_to_have_been_active_before = 'Колко време трябва да е активен текущият активен билет, преди да се затвори автоматично (по подразбиране \'\')';
_fc_props.settings.ticket_max_activate_age_minutes = 'Максимална възраст за активиране на билети (минути)';
_fc_props.settings.how_old_in_minutes_can_a_ticket_be_when_activating_it_in_trackit_default_ = 'На колко години в минути може да бъде даден билет, когато се активира в TrackIt (по подразбиране \'\')';
_fc_props.settings.max_hotspot_unused_days = 'Максимален брой неизползвани дни на гореща точка';
_fc_props.settings.sets_the_max_days_a_hotspot_can_be_unused_and_still_be_revived = 'Задава максималния брой дни, през които дадена гореща точка може да бъде неизползвана и въпреки това да бъде възобновена';
_fc_props.settings.radius_multiplier = 'Множител на радиуса';
_fc_props.settings.what_to_multiply_the_radius_by_when_a_ticket_is_received_from_the = 'По колко да се умножи радиусът, когато се получи билет от диспечерската система';
_fc_props.settings.ticket_message_date_format = 'Формат на датата на съобщението за билет';
_fc_props.am = 'съм';
_fc_props.pm = 'следобед';
_fc_props.settings.ticket_message = 'Съобщение за билет';
_fc_props.settings.add_ticket_element = 'Добавяне на елемент от билета';
_fc_props.driver_performance = 'Производителност на водача';
_fc_props.update_failed_can_not_connect = 'Актуализацията е неуспешна: Не може да се осъществи връзка със сървлета.';
_fc_props.company = 'Компания';
_fc_props.unknown_error = 'Неизвестна грешка';
_fc_props.selected = 'Избрано';
_fc_props.web_service = 'Уеб услуга';
_fc_props.error_processing_request = 'Грешка при обработката на заявката.';
_fc_props.email_address = 'Имейл адрес';
_fc_props.id = 'Идентификационен номер';
_fc_props.last_used = 'Последно използвано';
_fc_props.error_invalid_vehiclenum = 'Грешка Невалиден номер на превозно средство';
_fc_props.error_vehicle_is_not_logged_in = 'Грешка: Превозното средство не е регистрирано.';
_fc_props.status_timer = 'Таймер за състояние';
_fc_props.warning = 'Предупреждение';
_fc_props.users = 'Потребители';
_fc_props.you_dont_have_access_to_this_page = 'Нямате достъп за преглед на тази страница. Моля, свържете се със системния си администратор за достъп.';
_fc_props.previous_week = 'Предишна седмица';
_fc_props.status_breakdown = 'Разбивка на състоянието';
_fc_props.select_plant_or_employee_group = 'Трябва да изберете или завод, или група служители.';
_fc_props.cannot_select_plant_and_employee_group = 'Не можете да изберете едновременно завод и група служители.';
_fc_props.odometer_must_be_a_number = 'Началният километраж трябва да е число';
_fc_props.ending_odometer_must_be_a_number = 'Крайният километраж трябва да е число';
_fc_props.beginning_hour_meter_must_be_a_number = 'Началният брояч на часове трябва да е число';
_fc_props.ending_hour_meter_must_be_a_number = 'Крайният брояч на часове трябва да е число';
_fc_props.error_loading_status_change_page = 'Грешка при зареждане на страницата за промяна на статуса.';
_fc_props.x_is_an_invalid_time_format = '{0} е невалиден формат за време, трябва да бъде ГГГГ-ММ-ДД ЧЧ:ММ:СС';
_fc_props.x_for_schedule_login = '{0} за вход по график';
_fc_props.x_for_schedule_logout = '{0} за планиране на излизане';
_fc_props.x_for_actual_login = '{0} за действително влизане';
_fc_props.x_for_actual_logout = '{0} за действително излизане';
_fc_props.by_refreshing_the_time_card_detail = 'С обновяване на детайлите на картата за работно време ще загубите всички промени, искате ли да продължите?';
_fc_props.are_you_sure_you_want_to_delete_0 = 'Сигурни ли сте, че искате да изтриете {0}?';
_fc_props.settings.command_mobile_ticket_url = 'URL адрес на билет за мобилна команда';
_fc_props.year = 'Година';
_fc_props.make = 'Направи';
_fc_props.model = 'Модел';
_fc_props.settings.command_mobile_ticket_password = 'Парола за билети на Command Mobile';
_fc_props.settings.command_mobile_ticket_auth_token = 'Токен за удостоверяване на мобилен билет за Command';
_fc_props.target = 'Цел';
_fc_props.number_of_digits = 'Брой цифри';
_fc_props.number_of_integer_digits = 'Брой цели цифри';
_fc_props.number_of_fractional_digits = 'Брой дробни цифри';
_fc_props.search = 'Търсене';
_fc_props.settings.command_mobile_ticket_date_order = 'Поръчка на дата на билет за Command Mobile';
_fc_props.settings.command_mobile_ticket_date_length = 'Продължителност на датата на билета за Command Mobile';
_fc_props.settings.command_mobile_ticket_date_separator = 'Разделител на датата на билета Command Mobile';
_fc_props.settings.command_mobile_ticket_slash = '/ (наклонена черта)';
_fc_props.settings.command_mobile_ticket_dash = '- (тире)';
_fc_props.settings.command_mobile_ticket_period = '. (точка)';
_fc_props.settings.command_mobile_ticket_space = '(пространство)';
_fc_props.settings.command_mobile_ticket_time_length = 'Продължителност на времето за билети за мобилен Command';
_fc_props.settings.command_mobile_ticket_time_separator = 'Разделител на време за билети за Command Mobile';
_fc_props.settings.command_mobile_ticket_colon = ': (двоеточие)';
_fc_props.settings.command_mobile_ticket_time_format = 'Формат на времето за билети за Command Mobile';
_fc_props.settings.command_mobile_ticket_use_interface_number = 'Използване на номер на интерфейс';
_fc_props.language = 'Език';
_fc_props.mechanic = 'Механик';
_fc_props.settings.command_mobile_ticket_poll_interval = 'Интервал на анкетата (секунди)';
_fc_props.driving_time = 'Време за шофиране';
_fc_props.find_near_plants = 'Намерете растения наблизо';
_fc_props.please_create_hot_spot_first = 'Моля, първо създайте точка за достъп';
_fc_props.pump = 'Помпа';
_fc_props.please_enter_hot_spot_description = 'Моля, въведете описание на горещата точка';
_fc_props.please_select_a_hot_spot_type = 'Моля, изберете тип гореща точка';
_fc_props.settings.command_mobile_ticket_send_driver_email = 'Изпрати имейл на шофьора';
_fc_props.directions_not_found = 'Невалиден адрес в {0}. Упътванията не са намерени.';
_fc_props.ws_user = 'Потребител';
_fc_props.ws_service = 'Услуга';
_fc_props.ws_method = 'Метод';
_fc_props.ws_params = 'Параметри';
_fc_props.units_kilometers_abbr = 'км';
_fc_props.units_miles_abbr = 'Мичиган';
_fc_props.origin_and_destination = 'Произход и дестинация';
_fc_props.liter_abbr = 'л';
_fc_props.help = 'Помощ';
_fc_props.settings.command_mobile_ticket_use_alt_emp_number = 'Използване на алтернативен номер на служител в Android';
_fc_props.settings.command_mobile_ticket_android_url = 'URL адрес на билет за мобилни устройства с Android';
_fc_props.settings.command_mobile_ticket_android_secret = 'Тайната на мобилния билет за Android';
_fc_props.employee_x_has_no_logout_on_y = 'Служител {0} няма изход от системата за смяна, започваща на {1}.';
_fc_props.phone_number_has_duplicates = 'Телефонните номера имат дублирани записи';
_fc_props.ounce = 'Унция';
_fc_props.water_extra = 'Вода допълнително';
_fc_props.always = 'Винаги';
_fc_props.work_types_must_be_unique = 'Видовете работа трябва да са уникални';
_fc_props.manufacturer = 'Производител';
_fc_props.need_to_enter_seconds = 'Трябва да въведете секунди.';
_fc_props.copy = 'Копиране';
_fc_props.create_in_existing_required = 'За да се създаде роуминг хотспот, трябва да е избрано „Създаване в съществуващо“.';
_fc_props.break = 'Прекъсване';
_fc_props.add_export_data_type = 'Добавяне на тип данни за експортиране';
_fc_props.edit_export_data_type = 'Редактиране на типа данни за експортиране';
_fc_props.delete_export_data_type = 'Изтриване на тип данни за експортиране';
_fc_props.export_data_type = 'Тип данни за експортиране';
_fc_props.error_updating_export_data_type = 'Грешка при актуализиране на типа експортирани данни';
_fc_props.settings.address_key = 'Адресен ключ';
_fc_props.settings.address_key_hover = 'Опции за адресен ключ';
_fc_props.settings.address_key_options = 'Опции за адресен ключ';
_fc_props.more_filter_options = 'Още опции за филтриране';
_fc_props.unauthorized_mapit_app = 'Тази версия на MapIt не е оторизирана, моля, актуализирайте MapIt възможно най-скоро.';
_fc_props.zello_timeout = 'Възникна таймаут при свързване със Zello.';
_fc_props.user_agreement_text = 'С влизането си в профила си, вие се съгласявате с';
_fc_props.user_agreement = 'потребителско споразумение';
_fc_props.upload = 'Качване';
_fc_props.x_mins_left = 'Остават {0} мин.';
_fc_props.continuous_location_tracking_colon = 'Непрекъснато проследяване на местоположението:';
_fc_props.hired_hauler_cannot_register_device = 'Наетият превозвач не може да регистрира ново устройство.';
_fc_props.timecard_does_not_contain_shift = 'Картата за работно време на служителя не съдържа предоставената смяна (информация за картата за работно време)';
_fc_props.timecard_not_found = 'Картата за работно време на служителя не е намерена';
_fc_props.vehicle_must_be_assigned_for_clt = 'Превозното средство трябва да бъде присвоено на местоположенията на релсите.';
_fc_props.vehicle_unassigned_continuous_tracking_disabled = 'Превозното средство не е било назначено, непрекъснатото проследяване ще бъде деактивирано.';
_fc_props.units_yards_abbr = 'YD';
_fc_props.units_meters_abbr = 'М';
_fc_props.error_lost_edc_connection = 'Загубена е връзка с телематичното устройство. Моля, проверете дали вашият WiFi и/или Bluetooth са активирани.';
_fc_props.acknowledge_all = 'Потвърди всички';
_fc_props.expand = 'Разгъване';
_fc_props.collapse = 'Свиване';
_fc_props.expand_all = 'Разгъване на всички';
_fc_props.collapse_all = 'Свий всички';
_fc_props.last_update = 'Последна актуализация';
_fc_props.acknowledge_alert = 'Потвърждаване на предупреждение';
_fc_props.acknowledge_message = 'Потвърждаване на съобщението';
_fc_props.acknowledge_all_alerts = 'Потвърждаване на всички сигнали';
_fc_props.acknowledge_all_messages = 'Потвърждаване на всички съобщения';
_fc_props.eta = 'Очаквано време';
_fc_props.tolerance_must_be_a_valid_integer = 'Толерансът трябва да е валидно цяло число между -99 и 99 (включително и двете)';
_fc_props.gps_permission_required = 'Необходимо е разрешение за GPS';
_fc_props.permissions_required = 'Необходими разрешения';
_fc_props.change_user = 'Промяна на потребителя';
_fc_props.account_not_registered_with_carrier = 'Този акаунт не е регистриран при оператор';
_fc_props.slump_loss = 'Загуба на спад';
_fc_props.slump_loss_help = 'Помощ при спад';
_fc_props.did_not_receive_any_edc_devices = 'Не получих никакви устройства.';
_fc_props.edc_record_not_found = 'Записът на телематичното устройство не е намерен';
_fc_props.disable_hotspot_prompt = 'Моля, докоснете „OK“, когато бъдете подканени да деактивирате вашата точка за достъп.';
_fc_props.edc_device_is_in_use = 'Телематичното устройство {0} се използва.';
_fc_props.an_unknown_exception_has_occurred = 'Възникна неизвестно изключение';
_fc_props.login_has_timed_out = 'Времето за влизане изтече';
_fc_props.use_paper_logs = 'Използвайте хартиени дневници';
_fc_props.eld_login_failed = 'Входът в „Работно време“ не бе успешен';
_fc_props.setup_time_off_type = 'Моля, задайте вид почивка.';
_fc_props.view_load_properties = 'Преглед на свойствата на натоварването';
_fc_props.couldnt_download_edc_firmware = 'Не можа да се изтегли фърмуерът на телематичното устройство.';
_fc_props.password_incorrect = 'Паролата е неправилна';
_fc_props.edc_configuration_password_prompt = 'Поради състоянието на това устройство, трябва да предоставите паролата на инсталатора, за да го конфигурирате.';
_fc_props.edc_configuration_check_failed = 'Валидирането на записите на сървъра на телематичното устройство не бе успешно. Моля, проверете съобщенията за грешки за подробности.';
_fc_props.configuration_issues_prompt = 'Следните проблеми бяха открити при конфигурирането на избраното телематично устройство за посочения камион';
_fc_props.checking_password = 'Проверка на паролата';
_fc_props.reset_password_instructions_sent = 'Инструкции за възстановяване на паролата ви са изпратени на имейл адрес {0}.';
_fc_props.reset_password_failed = 'Нулирането на паролата не бе успешно, опитайте отново.';
_fc_props.forgot_password = 'Забравена парола?';
_fc_props.enter_valid_email = 'Невалиден имейл адрес, моля, въведете валиден имейл адрес и опитайте отново.';
_fc_props.issues_while_updating_edc_record = 'Телематичното устройство беше конфигурирано успешно. Има обаче проблеми със записите за устройството на сървъра на TrackIt, които може да доведат до нефункциониране. Моля, обадете се на поддръжката, за да коригирате информацията.';
_fc_props.sending = 'Изпраща се...';
_fc_props.minimum_ratio = 'Минимално съотношение';
_fc_props.vin = 'VIN';
_fc_props.probe_rpm_not_in_range = 'Оборотите на барабана не са в диапазона';
_fc_props.probe_failure = 'Повреда на сондата';
_fc_props.unknown_probe_data_failure = 'Неизвестна грешка в данните от сондата';
_fc_props.no_loaded_status_meaning = 'Няма зареден статус';
_fc_props.no_depart_status_meaning = 'Няма статус на заминаване';
_fc_props.no_arrive_status_meaning = 'Няма статус на пристигане';
_fc_props.no_begin_work_status_meaning = 'Няма статус на започване на работа';
_fc_props.no_fully_mixed_status_meaning = 'Няма напълно смесен статус';
_fc_props.no_begin_work_or_at_job_status = 'Няма статуси „Започване на работа“ или „На работа“';
_fc_props.driver_didnt_follow_procedure = 'Шофьорът не е спазил процедурата (не е забавил барабана)';
_fc_props.probe_malfunction = 'Неизправност на сондата (вътрешна повреда и др.)';
_fc_props.no_data_from_probe = 'Няма данни от сондата (загуба на данни)';
_fc_props.missing_probe_calibration = 'Няма данни за калибриране на сондата';
_fc_props.probe_pressure_not_in_range = 'Налягането на сондата не е в обхвата';
_fc_props.arrival = 'Пристигане';
_fc_props.small_load = 'МАЛЪК ТОВАР';
_fc_props.dry_slump = 'СУХ СПАД';
_fc_props.probe_remixing_turns = 'Ремиксиране';
_fc_props.turns_needed_to_remix = 'Добавена вода - Необходимо е допълнително разбъркване';
_fc_props.probe_remixing_finished = 'Ремиксирането е завършено';
_fc_props.probe_battery_low_alert = 'Предупреждение за изтощена батерия на сондата';
_fc_props.probe_battery_low_message = 'Ниска батерия на сондата';
_fc_props.probe_battery_low = 'Ниска батерия на сондата';
_fc_props.alert_when_probe_battery_low = 'Предупреждение, когато батерията на сондата е изтощена';
_fc_props.probe_sensor_fatal_failure = 'Фатална повреда на сензора';
_fc_props.probe_thermistor_failure = 'Повреда на термистора';
_fc_props.probe_sensor_stuck_in_concrete = 'Сензор, заседнал в бетон';
_fc_props.probe_sensor_over_weight = 'Сензор за претоварване';
_fc_props.probe_batteries_low = 'Изтощена батерия';
_fc_props.no_probe_data = 'Няма данни от сондата:';
_fc_props.check_probe = 'Проверете сондата';
_fc_props.service_probe = 'Сервизна сонда';
_fc_props.below_x = 'Под {0}';
_fc_props.above_x = 'Над {0}';
_fc_props.probe_serial_number_invalid_format = 'Серийният номер на сондата не е във валиден формат, както е показано в заместителя за полето';
_fc_props.talk_dnd_permission_prompt = 'За разговора е необходимо разрешение „НЕ БЕЗПОКОЙТЕ“.';
_fc_props.max = 'Макс';
_fc_props.status_changed_quickly = 'Статусът се промени твърде бързо';
_fc_props.is_empty = 'Празно е';
_fc_props.slump_increased_plasticizer_question = 'Добавен ли е пластификатор?';
_fc_props.slump_increased_water_added_question = 'Колко немерирана вода е добавена?';
_fc_props.probe_and_drs_are_not_support_together_on_the_same_device = 'Мониторингът на сондата и цикъла на доставка не се поддържат едновременно на едно и също устройство.';
_fc_props.no_data_from_sensor = 'Няма данни от сензора (загуба на данни)';
_fc_props.dvir = 'ДВИР';
_fc_props.system_type = 'Тип система';
_fc_props.magnet_count = 'Брой магнити';
_fc_props.sensors_setup = 'Настройка на сензори';
_fc_props.drs_requires_io_mac_sensor_drum_type_magnet_count = 'DCM изисква да бъдат зададени MAC адрес на входно/изходната кутия, тип барабан, тип DCM и брой магнити.';
_fc_props.drs = 'DCM';
_fc_props.drs_ticketed_volume = 'Обем на заявените билети';
_fc_props.drs_current_volume = 'Текущ обем';
_fc_props.drs_current_water_cement_ratio = 'Текущо съотношение вода/цимент';
_fc_props.drs_target_water_cement_ratio = 'Целево съотношение вода/цимент';
_fc_props.drs_total_revolutions = 'Общо';
_fc_props.drs_current_volume_lp_small = 'Текущ';
_fc_props.drum_revolutions = 'Барабанни революции';
_fc_props.drs_total_revolutions_lp_small = 'Общо';
_fc_props.drs_charging_revolutions_lp_small = 'Зареждане';
_fc_props.drs_discharging_revolutions_lp_small = 'Разреждане';
_fc_props.drs_target_wc_lp_small = 'Целева тоалетна';
_fc_props.drs_current_wc_lp_small = 'Текуща вода/вода';
_fc_props.drs_ticketed_volume_lp_small = 'Билет';
_fc_props.android_location_disclosure = 'TrackIt използва фино и грубо местоположение, за да събира данни за местоположението във фонов режим, дори когато не се използва, за да се даде възможност за автоматично определяне на статуса и видимост на картата в реално време за изпращане.';
_fc_props.android_location_usage = 'Разкриване на местоположение';
_fc_props.end_pour_trigger_threshold = 'Праг на задействане при крайно изливане';
_fc_props.drs_wiring_error = 'Грешка в окабеляването';
_fc_props.drs_wiring_pulse_error = 'Грешка в импулса на окабеляване';
_fc_props.drs_wiring_magnet_error = 'Грешка в магнита за окабеляване';
_fc_props.drs_magnet_missing_error = 'Грешка при липсващ магнит';
_fc_props.android_location_disclosure_3p = 'TrackIt събира данни за местоположението във фонов режим, за да осигури автоматично определяне на статуса и видимост на картата в реално време за изпращане. Когато местоположението е записано от изпращача, то не се споделя.';
_fc_props.please_select_either_fullmdm_or_trackit_remote_support = 'Моля, изберете или „Пълна MDM“, или „Trackit дистанционна поддръжка“';
_fc_props.move_up = 'Премести нагоре';
_fc_props.move_down = 'Премести надолу';
_fc_props.driver_not_found = 'Шофьорът не е намерен.';
_fc_props.multiple = 'Множество';
_fc_props.water_meter_installed = 'Монтиран водомер';
_fc_props.delete_waypoint = 'Изтриване на точка от пътя';
_fc_props.wash_sensor_installed = 'Сензорът за измиване е инсталиран';
_fc_props.washing_start_time = 'Време за начало на прането';
_fc_props.end_washing = 'Край на прането';
_fc_props.variable_rpms = 'Var RPMs';
_fc_props.no_slump = 'Без спад';
_fc_props.end_washing_duration = 'Край на времето за пране';
_fc_props.privacy_policy = 'Политика за поверителност';
_fc_props.privacy_policy_text = 'Прочетох и приемам';
_fc_props.login_fail_accept_privacy_policy = 'Политиката за поверителност трябва да бъде приета, за да продължите.';
_fc_props.rotation_sensor = 'Сензор за въртене';
_fc_props.pto_sensor = 'Сензор за ВОМ';
_fc_props.pto_sensor_installed = 'Сензорът за ВОМ е инсталиран';
_fc_props.polarity_reversed = 'Обратна полярност';
_fc_props.pto_sensor_type = 'Тип сензор за ВОМ';
_fc_props.sensor_type = 'Тип сензор';
_fc_props.prompt_select_pto_sensor_type = 'Трябва да изберете „Тип сензор за ВОМ“, ако сте избрали „Сензор за ВОМ“ като основен тип сензор.';
_fc_props.priming_turns_at_full_load = 'Грундирането се завърта при пълно натоварване';
_fc_props.priming_turns_at_ten_percent_load = 'Грундирането се завърта при 10% натоварване';
_fc_props.weight_units = 'Единици за тегло';
_fc_props.settings.send_status = 'Изпращане на състояние/местоположение до моста на събитията';
_fc_props.volume_difference = 'Разлика в обема';
_fc_props.mobile_ticket_iframe_url = 'URL адрес на IFrame за мобилен билет';
_fc_props.mobile_ticket_user = 'Потребител на мобилен билет';
_fc_props.mobile_ticket_password = 'Парола за мобилен билет';
_fc_props.current_truck_status = 'Текущо състояние на камиона';
_fc_props.estimated_symbol = '℮';
_fc_props.almost_equal_to_symbol = '≈';
_fc_props.triggered_by_max_revolutions = 'Задейства се от максимални обороти';
_fc_props.alerts_by_type = 'Сигнали по тип';
_fc_props.water_flow_meter = 'Измервател на дебита на водата';
_fc_props.flow_meter_no_pulses_warning = 'Няма импулси - Предупреждение';
_fc_props.flow_meter_no_pulses_critical = 'Няма импулси - критично';
_fc_props.flow_meter_excessive_pulses = 'Прекомерни импулси';
_fc_props.flow_meter_constantly_flowing = 'Постоянно течащ';
_fc_props.flow_meter_good = 'Добре';
_fc_props.whats_new = 'Какво е новото';
_fc_props.whats_new_widget_text = 'Знаете ли, че актуализираме TrackIt поне веднъж месечно? Получавайте най-новите актуализации и съвети.';
_fc_props.get_the_scoop = 'Вземете новината';
_fc_props.trackit_insights = 'Trackit Insights';
_fc_props.business_analytics_blurb = 'Бизнес анализи, които подобряват крайния ви резултат, вече са включени в TrackIt';
_fc_props.find_out_more = 'Научете повече';
_fc_props.daily_breakdown = 'Дневен разбив';
_fc_props.question_summary = 'Резюме на въпроса';
_fc_props.trip_summary = 'Резюме на пътуването';
_fc_props.manage_employees = 'Управление на служителите';
_fc_props.manage_hotspots = 'Управление на горещи точки';
_fc_props.manage_devices = 'Управление на устройства';
_fc_props.manage_equipment = 'Управление на оборудването';
_fc_props.manage_users = 'Управление на потребители';
_fc_props.manage_statuses = 'Управление на състоянията';
_fc_props.manage_alerts = 'Управление на сигнали';
_fc_props.popular_report_links = 'Популярни връзки към отчети';
_fc_props.popular_settings_links = 'Връзки към популярни настройки';
_fc_props.sidemenu_settings = 'Настройки';
_fc_props.loads_per_driver = 'Товари на шофьор';
_fc_props.please_select_application = 'Моля, изберете поне едно приложение';
_fc_props.external_app_processing = 'Обработка във външно приложение';
_fc_props.external_app_sent = 'Изпратено до външно приложение';
_fc_props.external_app_received = 'Получено от външно приложение';
_fc_props.wait_time_at_job = 'Време за чакане на работното място';
_fc_props.wait_time_at_plant = 'Време за изчакване в завода';
_fc_props.loading_time = 'Време за зареждане';
_fc_props.unloading_time = 'Време за разтоварване';
_fc_props.pre_post_trip = 'Преди/След пътуване';
_fc_props.update_thresholds = 'Актуализиране на праговете';
_fc_props.green = 'Зелено';
_fc_props.yellow = 'Жълто';
_fc_props.red = 'Червено';
_fc_props.between = 'Между';
_fc_props.num_of_loads = '# товари';
_fc_props.num_of_drivers = '# шофьори';
_fc_props.status_meaning_not_setup = 'Статус Значение не е настроено';
_fc_props.or_less = 'Или по-малко';
_fc_props.or_greater = 'Или по-голямо';
_fc_props.probe_self_diagnostic_state = 'Състояние на самодиагностика на сондата';
_fc_props.update_current_truck_status_settings = 'Актуализиране на настройките за текущо състояние на камиона';
_fc_props.default_behavior = 'По подразбиране (Топ 10 статуса)';
_fc_props.combine_similar_statuses = 'Комбиниране на едни и същи състояния от всички типове (цикли)';
_fc_props.use_other_category = 'Използвайте категорията „Други“';
_fc_props.selected_statuses = 'Избрани статуси';
_fc_props.ideas = 'Идеи';
_fc_props.air_content = 'Съдържание на въздуха';
_fc_props.air_measured_time = 'Време, измерено във въздуха';
_fc_props.ten_max = '10 Макс';
_fc_props.loads_per_plant = 'Натоварвания на инсталация';
_fc_props.invalid_flow_meter_pulse_per_volume = 'Невалиден импулс на разходомера за обем.';
_fc_props.coming_soon_title = 'Очаквайте скоро още джаджи';
_fc_props.submit_your_ideas = 'Изпратете идеите си до нашия Портал за идеи, като използвате „Крушката“ в лявото навигационно меню.';
_fc_props.selected_plants = 'Избрани растения';
_fc_props.update_loads_per_plant_settings = 'Актуализиране на настройките за натоварвания по инсталация';
_fc_props.default_top_10_plants = 'По подразбиране (Топ 10 растения)';
_fc_props.phone_number_will_be_uploaded = 'Идентификаторът на устройството ще бъде качен за целите на регистрацията.';
_fc_props.include_deleted = 'Включи изтритите';
_fc_props.primary_status_type = 'Тип основен статус';
_fc_props.additional_status_trigger = 'Допълнителни тригери за състояние';
_fc_props.update_tickets_destination = 'Актуализиране на дестинацията на всички свързани билети';
_fc_props.settings.send_destination_changes_to_connex = 'Изпращане на промени в дестинацията до Connex';
_fc_props.settings.is_the_ticket_active_when_it_is_received_by_trackit_default_always = 'Билетът активен ли е, когато бъде получен от TrackIt (по подразбиране „винаги“)';
_fc_props.settings.autoactivate_next_ticket_on_ticket_completion = 'Автоматично активиране на следващия билет при попълване на предишния билет';
_fc_props.settings.should_autoactivate_next_ticket_on_ticket_completion_default_true = 'Трябва да се активира автоматично следващият билет при попълване на билета (по подразбиране „true“)';
_fc_props.settings.status_to_idle_status_when_no_active_ticket = 'Статус към неактивен статус, когато няма активен билет';
_fc_props.break_down = 'Разбивка';
_fc_props.idle = 'Бездействие';
_fc_props.pto_work_maximum_speed_limit = 'Максимална работна скорост';
_fc_props.settings.associate_ticket_to_status_on_complete = 'Промяна на статуса на асоцииране, която завършва билет с този билет';
_fc_props.approaching = 'Приближаване';
_fc_props.performing_task = 'Изпълнение на задача';
_fc_props.are_you_sure_you_want_to_delete_geogate = 'Сигурни ли сте, че искате да изтриете геопорта {0}?';
_fc_props.trackit_destination_changed_to_0 = 'Актуализиране на билет {0}. Дестинацията е променена.';
_fc_props.trackit_return_destination_changed_to_0 = 'Актуализиране на билет {0}. Връщането е променено.';
_fc_props.menu_settings_title_geogate = 'Географска порта';
_fc_props.add_geogate = 'Добавяне на геопорт';
_fc_props.driver_enabled = 'Шофьорът е активиран';
_fc_props.dispatcher_enabled = 'Диспечерът е активиран';
_fc_props.runsheet_number = 'Номер на работен лист';
_fc_props.manual_load = 'Ръчно зареждане';
_fc_props.delivery = 'Доставка';
_fc_props.return_run = 'Връщане на бягане';
_fc_props.home_run = 'Хоумрън';
_fc_props.edit_geogate = 'Редактиране на геопорт';
_fc_props.handling = 'Работа';
_fc_props.geogate_name = 'Географска порта';
_fc_props.geogate_panel = 'Геоврата панел';
_fc_props.vehicle_is_not_logged_in = 'Съобщението не е изпратено (превозното средство не е влязло в системата)';
_fc_props.air = 'Въздух';
_fc_props.create_a_geogate = 'Създайте геопорта';
_fc_props.click_the_map_to_set_the_geogate_points = 'Щракнете върху картата, за да зададете точките на геопорта.';
_fc_props.clock_out = 'Часовник извън';
_fc_props.handling_operation = 'Работа с машини';
_fc_props.view_geogates = 'Вижте геопортите';
_fc_props.select_a_geogate = 'Моля, изберете геопорта';
_fc_props.failed_to_find_geogate = 'Неуспешно намиране на Геогайт';
_fc_props.adjust_geogate = 'Регулиране на геогейт';
_fc_props.geogate_expiration_date_time_extra_days = 'Дата на изтичане на географската врата Час По подразбиране Допълнителни дни';
_fc_props.menu_settings_title_retention = 'Съхранение на данни';
_fc_props.category = 'Категория';
_fc_props.telemetry = 'Телеметрия';
_fc_props.ticket_data = 'Данни за билети';
_fc_props.driver_break = 'Почивка на шофьора';
_fc_props._30_days = '30 дни';
_fc_props._6_months = '6 месеца';
_fc_props._1_year = '1 година';
_fc_props._3_years = '3 години';
_fc_props.discharge = 'Изхвърляне';
_fc_props.new_group = 'Нова група';
_fc_props.selected_vehicles = 'Избрани превозни средства';
_fc_props.group_name_is_required_field = 'Полето „Име на групата“ е задължително';
_fc_props.at_least_vehicle_should_be_selected = 'Трябва да бъде избрано поне 1 превозно средство';
_fc_props.groups = 'Групи';
_fc_props.trucks = 'Камиони';
_fc_props.geogate_has_been_removed_please_refresh_page = 'Географският портал е премахнат. Моля, опреснете страницата.';
_fc_props.air_timestamp = 'Времева марка на ефир';
_fc_props.fail = 'НЕУСПЕХ';
_fc_props.stuck = 'ЗАЛЕПЕН';
_fc_props.dirty = 'Мръсно';
_fc_props.driver_breakdown = 'Разбивка';
_fc_props.seasonal = 'Сезонен';
_fc_props.category_details = 'Детайли за категорията';
_fc_props.alert_events = 'Събития с предупреждения';
_fc_props.driver_performance_infractions = 'Нарушения на поведението на водача';
_fc_props.telemetry_details = 'Данни за местоположение, горещи точки, време в горещи точки, време в региони, данни от DCM, данни от сондата, данни от двигателя';
_fc_props.ticket_data_details = 'Данни за билети';
_fc_props.general_details = 'Промени в статуса, карти за работно време, графици';
_fc_props.wash = 'Измиване';
_fc_props.filter_options = 'Опции за филтриране';
_fc_props.home_plants = 'Домашни растения';
_fc_props.delivery_multidrop = 'Многоточкова доставка';
_fc_props.dcm = 'DCM';
_fc_props.pto_requires_pto_sensor_type_value = 'DCM PTO изисква да бъде зададен тип сензор за PTO.';
_fc_props.invalid_io_box_mac_address = 'Невалиден Mac адрес на входно/изходната кутия';
_fc_props.access_denied = 'Достъпът е отказан';
_fc_props.wash_events = 'Събития за пране';
_fc_props.min_speed = 'Мин. скорост';
_fc_props.temperature_change = 'Промяна на температурата';
_fc_props.degrees_cap = 'Степени';
_fc_props.washout_tracking = 'Проследяване на отмиването';
_fc_props.approaching_wash = 'Приближаване към Уош';
_fc_props.arrival_wash = 'Пристигане Пране';
_fc_props.performing_wash = 'Извършване на пране';
_fc_props.wash_complete = 'Прането е завършено';
_fc_props.must_be_positive_or_zero = 'Трябва да е положително или нула!';
_fc_props.min_speed_greater_than_max = 'Мин. скорост трябва да е по-малка от максималната скорост!';
_fc_props.clock_in = 'Вход';
_fc_props.mix_water_at_x_to_y_for_t = 'Смесвайте водата при {0} до {1} оборота в минута за {2} оборота.';
_fc_props.discharge_water_for_x_revolutions = 'Изпуснете водата за {0} оборота.';
_fc_props.eod_drum_wash_complete = 'Измиването на барабана е завършено! <br> Спрете барабана със сонда отгоре.';
_fc_props.washing_complete = 'Насоченото измиване е завършено';
_fc_props.eod_washout_no_data_available = 'Данните от сензора не са налични, моля, завършете процеса на измиване.';
_fc_props.eod_washout_no_data_available_title = 'Насочено измиване не е налично';
_fc_props.menu_reports_title_ticket_time_summary = 'Обобщение на времето за билети';
_fc_props.menu_reports_description_ticket_time_summary = 'Преглед на информация за времето на билета за поръчка или превозно средство';
_fc_props.menu_reports_title_summary = 'Обобщение';
_fc_props.menu_reports_title_ticket_summary = 'Резюме на билета';
_fc_props.menu_reports_description_summary1 = 'Преглед на обобщение на времето в горещи точки';
_fc_props.menu_dispatch_title_main = 'Главно';
_fc_props.menu_dispatch_title_login_registry = 'Вход в регистъра';
_fc_props.menu_reports_title_main = 'Главно';
_fc_props.time_management_are_you_sure_you_want_to_delete_export_data_type = 'Сигурни ли сте, че искате да изтриете този тип експортирани данни?';
_fc_props.dvir_status_paper_logs = 'Хартиени дневници';
_fc_props.menu_reports_title_billing_report = 'Отчет за фактуриране';
_fc_props.menu_reports_description_billing_report = 'Отчет за фактуриране';
_fc_props.settings_status_to_ticketed_status_on_activate_work = 'Статус към Статус на заявка Активиране на работа';
_fc_props.settings_status_to_ticketed_status_on_activate_work_default_false = 'Статус към Статус на заявка При активиране на работа (по подразбиране „Невярно“)';
_fc_props.status_change_type_drum_rotation_sensor = 'DCM';
_fc_props.settings_connex_eid = 'Connex EID';
_fc_props.units_weight_pound_label = 'Паундове';
_fc_props.units_weight_kilogram_label = 'Килограми';
_fc_props.settings_weight = 'Тегло';
_fc_props.units_pounds = 'Паундове';
_fc_props.units_kilograms = 'Килограми';
_fc_props.geo_gate_edit_modal_description = 'Описание';
_fc_props.geo_gate_edit_modal_start_point = 'Начална точка';
_fc_props.geo_gate_edit_modal_end_point = 'Крайна точка';
_fc_props.geo_gate_edit_modal_vehicle_types = 'Тип оборудване';
_fc_props.geo_gate_edit_modal_heading_south = 'От юг на север';
_fc_props.geo_gate_edit_modal_heading_north = 'Север на юг';
_fc_props.geo_gate_edit_modal_driver_message = 'Съобщение на водача';
_fc_props.geo_gate_edit_modal_dispatcher_message = 'Съобщение за изпращане';
_fc_props.geo_gate_edit_modal_expiration_date_time = 'Дата на изтичане Време';
_fc_props.geo_gate_edit_modal_permanent = 'Постоянен';
_fc_props.geo_gate_edit_modal_critical = 'Критично';
_fc_props.geo_gate_edit_modal_error_message_description_empty = 'Грешка при запазване на геогейт: Полето за описание трябва да бъде попълнено.';
_fc_props.geo_gate_edit_modal_error_message_start_point_empty = 'Грешка при запазване на геогейт: Полето „Начална точка“ трябва да бъде попълнено.';
_fc_props.geo_gate_edit_modal_error_message_start_point_invalid_format = 'Грешка при запазване на Geogate: Полето „Начална точка“ съдържа невалиден формат на данните.';
_fc_props.geo_gate_edit_modal_error_message_end_point_invalid_format = 'Грешка при запазване на Geogate: Полето „Крайна точка“ съдържа невалиден формат на данните.';
_fc_props.geo_gate_edit_modal_error_message_expiration_date_time_empty = 'Грешка при запазване на Geogate: Полето „Дата на изтичане“ трябва да бъде попълнено.';
_fc_props.geo_gate_edit_modal_error_message_expiration_date_time_invalid_format = 'Грешка при запазване на Geogate: Полето „Дата на изтичане“ съдържа невалиден формат на данните.';
_fc_props.geo_gate_edit_modal_error_message_heading_north_dispatcher_message_empty = 'Грешка при запазване на геогейт: от север на юг - полето „Съобщение за изпращане“ трябва да бъде попълнено';
_fc_props.geo_gate_edit_modal_error_message_no_changes = 'Грешка при запазване на Geogate: Не са открити промени';
_fc_props.geo_gate_edit_modal_error_message_expiration_date_time_expired = 'Грешка при запазване на Geogate: Полето за дата и час на изтичане съдържа изтекла дата и час';
_fc_props.geo_gate_edit_modal_error_message_description_invalid_format = 'Грешка при запазване на Geogate: Полето за описание трябва да съдържа само букви и цифри';
_fc_props.geo_gate_edit_modal_error_message_vehicle_types_empty = 'Грешка при запазване на Geogate: Полето за тип оборудване трябва да бъде попълнено';
_fc_props.geo_gate_table_message_label_north_to_south = 'Север на юг';
_fc_props.geo_gate_table_message_label_south_to_north = 'От юг на север';
_fc_props.geo_gate_table_message_label_both = 'И двете';
_fc_props.geo_gate_edit_modal_field_point_tip = 'Географска ширина, географска дължина';
_fc_props.geo_gate_edit_modal_device_movement_message_restriction = 'Отметването на това ще отмени настройката за ограничение на съобщенията за движение на устройството';
_fc_props.geo_gate_edit_modal_seasonal = 'Сезонен';
_fc_props.geo_gate_edit_modal_error_message_seasonal_empty = 'Грешка при запазване на Geogate: Трябва да се попълнят сезонните дати';
_fc_props.geo_gate_edit_modal_error_message_seasonal_invalid_date_format = 'Грешка при запазване на Geogate: Полетата за сезонна дата съдържат невалиден формат на данните';
_fc_props.test_js_test_javascript = 'Тест на Javascript';
_fc_props.units_miles_per_hour_abbr = 'мили в час';
_fc_props.units_kilometers_per_hour_abbr = 'км/ч';
_fc_props.units_kilometers = 'Километри';
_fc_props.units_miles = 'Майлс';
_fc_props.units_gallons_abbr = 'ГАЛ';
_fc_props.units_liters_abbr = 'Л';
_fc_props.geo_gate_edit_modal_error_message_heading_south_driver_message_empty = 'Грешка при запазване на геогейт: от юг на север - полето „Съобщение на водача“ трябва да бъде попълнено';
_fc_props.geo_gate_edit_modal_error_message_heading_south_dispatcher_message_empty = 'Грешка при запазване на геогейт: от юг на север - полето за съобщение за изпращане трябва да бъде попълнено';
_fc_props.geo_gate_edit_modal_error_message_heading_north_driver_message_empty = 'Грешка при запазване на геогейт: от север на юг - полето „Съобщение на водача“ трябва да бъде попълнено';
_fc_props.geo_gate_heading = 'Заглавие';
_fc_props.geo_gate_edit_modal_error_message_end_point_empty = 'Грешка при запазване на географския портал: Полето за крайна точка трябва да бъде попълнено';
_fc_props.units_mile = 'Миля';
_fc_props.units_kilometer = 'Километър';
_fc_props.cloud_dvir__exit = 'Изход';
_fc_props.cloud_dvir__signature = 'Подпис';
_fc_props.cloud_dvir__inspection = 'Инспекция';
_fc_props.cloud_dvir__add_photos_notes = 'Добавяне на снимки/бележки';
_fc_props.cloud_dvir__odometer_reading = 'Отчитане на километража';
_fc_props.cloud_dvir__engine_hours = 'Моторни часове';
_fc_props.cloud_dvir__truck_details = 'Детайли за камиона';
_fc_props.cloud_dvir__determine_the_overall_condition_of_the_vehicle = 'Определете общото състояние на превозното средство';
_fc_props.cloud_dvir__full_name_and_signature_of_driver = 'Пълно име и подпис на водача';
_fc_props.cloud_dvir__sign = 'Знак';
_fc_props.cloud_dvir__driver_note_from = 'Бележка на водача от';
_fc_props.cloud_dvir__add_notes = 'Добавяне на бележки';
_fc_props.cloud_dvir__driver_notes = 'Бележки на водача';
_fc_props.cloud_dvir__done = 'Готово';
_fc_props.cloud_dvir__needs_repair = 'Нуждае се от ремонт';
_fc_props.cloud_dvir__not_applicable = 'Не е приложимо';
_fc_props.cloud_dvir__review_and_sign = 'Преглед и подпис';
_fc_props.cloud_dvir__add_photos = 'Добавяне на снимка';
_fc_props.cloud_dvir__upload_photo_limit = 'Можете да качите до 3 снимки';
_fc_props.cloud_dvir__mismatch_title = 'Сигнал за несъответствие';
_fc_props.cloud_dvir__ok = 'Добре';
_fc_props.cloud_dvir_template = 'Шаблон за облачен DVIR';
_fc_props.cloud_dvir__needs_review = 'DVIR се нуждае от преглед';
_fc_props.cloud_dvir__submitted = 'Изпратено';
_fc_props.cloud_dvir__completed_by = 'Завършено от';
_fc_props.cloud_dvir__review_btn = 'Преглед';
_fc_props.cloud_dvir__truck_number = 'Камион {0}';
_fc_props.cloud_dvir__pending_review = 'Предстои преглед';
_fc_props.cloud_dvir__start_dvir = 'Стартирайте DVIR';
_fc_props.cloud_dvir__dvir_history = 'История на DVIR';
_fc_props.cloud_dvir__view_all = 'Вижте всички';
_fc_props.load_zone = 'Зона на натоварване';
_fc_props.view_load_zones = 'Преглед на зоните на натоварване';
_fc_props.edit_load_zone = 'Редактиране на зона на натоварване';
_fc_props.create_a_load_zone = 'Създаване на зона на натоварване';
_fc_props.load_zone_panel = 'Панел на зоната на натоварване';
_fc_props.click_the_map_to_set_the_load_zone_center = 'Щракнете върху картата, за да зададете центъра на зоната на натоварване.';
_fc_props.cloud_dvir__mismatch_title_all_items_ok = 'Тази проверка е показала дефекти и вие сте избрали, че това превозно средство е безопасно за управление. Моля, проверете, преди да продължите.';
_fc_props.cloud_dvir__mismatch_title_needs_repair = 'Тази проверка не е показала дефекти и вие сте избрали, че това превозно средство е опасно за управление. Моля, проверете преди да продължите.';
_fc_props._90_days = '90 дни';
_fc_props.cloud_dvir = 'Облачен DVIR';
_fc_props.cloud_dvir_details = 'Изпращане на заявки за облачен DVIR';
_fc_props.show_load_zones = 'покажи зони на натоварване';
_fc_props.hide_load_zones = 'скриване на зоните за натоварване';
_fc_props.no = 'Не';
_fc_props.cloud_dvir__reset = 'Нулиране';
_fc_props.cloud_dvir__clear = 'Изчисти';
_fc_props.mark_read = 'Марк Рийд';
_fc_props.mark_unread = 'Маркирай като непрочетено';
_fc_props.read = 'Прочетете';
_fc_props.unread = 'Непрочетено';
_fc_props.air_sensor_serial_number = 'Сериен номер на сензора за въздух';
_fc_props.air_sensor_mac_address = 'MAC адрес на сензора за въздух';
_fc_props.air_sensor_serial_number_invalid_format = 'Серийният номер на сензора за въздух не е във валиден формат: (буквено-цифров и с дължина най-много 32 знака с тирета)';
_fc_props.air_sensor_mac_address_invalid_format = 'MAC адресът на сензора за въздух не е във валиден шестнадесетичен формат, както е показано в заместителя за полето';
_fc_props.air_sensor_license = 'Сензор за въздух';
_fc_props.adjust_route_point = 'Коригиране на точка от маршрута';
_fc_props.route_point_panel = 'Панел с точки от маршрута';
_fc_props.route_point = 'Точка на маршрута';
_fc_props.cloud_dvir__pre_trip = 'Преди пътуване';
_fc_props.cloud_dvir__post_trip = 'След пътуването';
_fc_props.cloud_dvir__other_insction_type = 'Друго';
_fc_props.cloud_dvir__dvir_completed = 'Завършено';
_fc_props.cloud_dvir__awaiting_mechanic = 'Чакащ механик';
_fc_props.cloud_dvir__awaiting_driver = 'Очаква се потвърждение от шофьора';
_fc_props.unable_to_check_air_sensor_serial_number_please_contact_support_for_assistance = 'Не може да се провери серийният номер на сензора за въздух, свържете се с поддръжката за допълнителна помощ.';
_fc_props.this_air_sensor_serial_number_exists_please_use_another_serial_number = 'Този сериен номер на сензор за въздух вече съществува, моля, използвайте друг сериен номер.';
_fc_props.unable_to_check_air_sensor_mac_address_please_contact_support_for_assistance = 'Не може да се провери MAC адресът на сензора за въздух, моля, свържете се с поддръжката за съдействие';
_fc_props.cloud_dvir__error_submit_dvir_title = 'Грешка при изпращане на DVIR';
_fc_props.cloud_dvir__error_submit_dvir_descr = 'Моля, опитайте отново';
_fc_props.ticket_integration_descr = 'Интеграцията на билети позволява задаване на настройки за интеграция на билети, както и начален екран / екран за зареждане / дисплей за твърдо монтиране';
_fc_props.cloud_dvir__success_submit_dvir_title = 'DVIR е успешно подаден';
_fc_props.cloud_dvir__inspection_trip_type = 'Вид инспекционно пътуване';
_fc_props.menu_dvir_title_mechanic = 'Механик';
_fc_props.sidemenu_dvir = 'ДВИР';
_fc_props.air_sensor_firmware = 'Фърмуер на сензора за въздух';
_fc_props.when_no_active_ticket = 'Когато няма активен билет';
_fc_props.used_by = 'Използвано от';
_fc_props.fields = 'Полета';
_fc_props.are_you_sure_you_want_to_delete_ticket_layout = 'Сигурни ли сте, че искате да изтриете оформлението на билета „{0}“?';
_fc_props.menu_settings_title_ticket_layout = 'Оформление на билета';
_fc_props.add_ticket_layout = 'Добавяне на оформление на билета';
_fc_props.edit_ticket_layout = 'Редактиране на оформлението на билета';
_fc_props.ticket_layout_edit_modal_name = 'Име';
_fc_props.ticket_layout_edit_modal_default = 'По подразбиране';
_fc_props.ticket_layout_edit_modal_error_message_name_empty = 'Грешка при запазване на оформлението на билета: Полето „Име“ трябва да бъде попълнено.';
_fc_props.ticket_layout_edit_modal_error_message_name_invalid_format = 'Грешка при запазване на оформлението на билета: Полето за име трябва да съдържа само букви и цифри';
_fc_props.ticket_layout_edit_modal_fields = 'Полета';
_fc_props.ticket_layout_edit_modal_usage = 'Употреба';
_fc_props.ticket_layout_has_been_removed_please_refresh_page = 'Оформлението на билета е премахнато. Моля, обновете страницата.';
_fc_props.more_lower_case = 'повече';
_fc_props.ticket_layout_edit_modal_error_selected_fields_are_empty = 'Грешка при запазване на оформлението на билета: Трябва да бъдат избрани едно или повече полета.';
_fc_props.ticket_layout_edit_modal_error_selected_statuses_are_empty = 'Грешка при запазване на оформлението на билета: Трябва да бъдат избрани един или повече статуси.';
_fc_props.cloud_dvir__ad_hoc = 'Специален';
_fc_props.radius_multiplier_should_be = 'Множител на радиуса трябва да е число с плаваща величина';
_fc_props.ticket_max_activate_age_err = 'Максималната възраст за активиране на билета (минути) трябва да е цяло число.';
_fc_props.max_hotspot_unused_days_errs = 'Максималният брой неизползвани дни на гореща точка трябва да е цяло число.';
_fc_props.begin_pour_air_content = 'Започнете да изсипвате съдържанието на въздух';
_fc_props.arrival_air_content = 'Съдържание на въздушния транспорт при пристигане';
_fc_props.fully_mixed_air_content = 'Напълно смесено съдържание на въздух';
_fc_props.departure_air_content = 'Съдържание на самолета за заминаване';
_fc_props.popup_enabled = 'Изскачащият прозорец е активиран';
_fc_props.popup_disabled = 'Изскачащите прозорци са деактивирани';
_fc_props.cloud_dvir__leave_confirmation_title = 'Предупреждение';
_fc_props.cloud_dvir__leave_confirmation_description = 'Излизането от страницата сега ще доведе до загуба на всички промени.';
_fc_props.cloud_dvir__leave_confirmation_approve = 'Потвърди';
_fc_props.cloud_dvir__leave_confirmation_abort = 'Отказ';
_fc_props.air_bt_ratio = 'Измерване на въздушен сензор';
_fc_props.cloud_dvir__view_photos_notes = 'Преглед на снимки/бележки';
_fc_props.error_adding_the_status_it_will_create_a_blank_usage_in_another_ticket_layout = 'Добавянето на статуса ще създаде празно поле за употреба в друг оформление на заявката. Искате ли да продължите с добавянето?';
_fc_props.vehicle_does_not_have_air_sensor_license = 'Превозното средство няма лиценз за сензор за въздух.';
_fc_props.air_sensor_installed = 'Инсталиран сензор за въздух';
_fc_props.load_card = 'Зареждане на карта';
_fc_props.cloud_dvir__inspection_profile = 'Профил на инспекцията';
_fc_props.cloud_dvir__view_details = 'Преглед на подробностите';
_fc_props.cloud_dvir__certify_repairs = 'Сертифициране на ремонти';
_fc_props.cloud_dvir__repairs_made = 'Извършени ремонти';
_fc_props.cloud_dvir__repairs_not_necessary = 'Ремонти не са необходими';
_fc_props.cloud_dvir__mechanic_note_from = 'Бележка от механик';
_fc_props.cloud_dvir__mechanic_assignment = 'Задание за механик';
_fc_props.cloud_dvir__mechanic_signature_description = 'Маркирайте всички приложими елементи по-долу и подпишете, че превозното средство е било правилно проверено.';
_fc_props.cloud_dvir__condition_satisfactory_label = 'Състоянието на това превозно средство е задоволително';
_fc_props.cloud_dvir__defects_corrected_label = 'Дефектите са коригирани';
_fc_props.cloud_dvir__repair_not_required_label = 'Не е необходим ремонт за безопасна експлоатация на превозното средство';
_fc_props.safety = 'Безопасност';
_fc_props.cloud_dvir__awaiting_sign = 'Очакващ знак';
_fc_props.cloud_dvir__dvir_review = 'Преглед на DVIR';
_fc_props.settings.mobile_auto_start_navigation = 'Автоматично стартиране на навигацията на мобилни устройства';
_fc_props.cloud_dvir__edit = 'Редактиране';
_fc_props.delete_custom_label = 'Изтриване на персонализиран етикет';
_fc_props.cloud_dvir__error_incompatible_aux_version = 'Вашата версия на TrackIt е остаряла и някои функции на DVIR може да не работят правилно. Моля, актуализирайте TrackIt, преди да продължите.';
_fc_props.cloud_dvir__error_submit_dvir_signature = 'Нещо се обърка при качването на подписа. Моля, опитайте отново.';
_fc_props.max_hotspot_unused_days_error = 'Максималният брой неизползвани дни на гореща точка е 1000 дни.';
_fc_props.menu_dvir_title_admin_templates = 'Шаблони';
_fc_props.menu.dvir = {};
_fc_props.menu.dvir.admin = {};
_fc_props.menu.dvir.admin.title = 'Администратор';
_fc_props.cloud_dvir__admin_templates = 'Шаблони';
_fc_props.form_name = 'Име на формуляра';
_fc_props.form_status = 'Състояние на формуляра';
_fc_props.menu.dvir.title = 'ДВИР';
_fc_props.cloud_dvir__option_download = 'Изтегляне';
_fc_props.cloud_dvir__option_view = 'Преглед';
_fc_props.cloud_dvir__inspectortype_driver = 'Шофьор';
_fc_props.menu.dvir.description = {};
_fc_props.menu.dvir.description.admin = 'Преглед/Редактиране/Създаване на персонализирани DVIR формуляри и заявки';
_fc_props.menu.dvir.description.mechanic = 'Преглед/редактиране на приложими DVIR заявления';
_fc_props.not_in_use = 'Не се използва';
_fc_props.logged_in = 'влязъл/а';
_fc_props.reviewing_driver = 'Преглед на драйвера';
_fc_props.cloud_dvir__report_title = 'Протокол от проверка на превозното средство на водача';
_fc_props.cloud_dvir__report_signed = 'подписан';
_fc_props.cloud_dvir__report_page_counter = 'Страница {0} от {1}';
_fc_props.cloud_dvir__report_defects = 'Дефекти';
_fc_props.cloud_dvir__report_comments = 'Коментари';
_fc_props.cloud_dvir__report_inspection_table_title = 'Оглед на превозното средство';
_fc_props.cloud_dvir__report_driver_table_title = 'Информация за водача';
_fc_props.cloud_dvir__report_carrier = 'Превозвач';
_fc_props.cloud_dvir__report_truck = 'Камион';
_fc_props.cloud_dvir__report_location = 'Местоположение';
_fc_props.cloud_dvir__report_odometer = 'Километраж';
_fc_props.cloud_dvir__report_hours = 'Часове';
_fc_props.cloud_dvir__report_no_comments = 'Няма коментари';
_fc_props.include_unlicensed_vehicles = 'Включва нелицензирани превозни средства';
_fc_props.cloud_dvir__search_by_form_name = 'Търсене по име на формуляр';
_fc_props.cloud_dvir__create_dvir = 'Създайте DVIR';
_fc_props.cloud_dvir__update_dvir = 'Актуализиране на DVIR';
_fc_props.cloud_dvir__form_name = 'Име на формуляра';
_fc_props.cloud_dvir__form_description = 'Описание на формуляра';
_fc_props.cloud_dvir__form_status = 'Състояние на формуляра';
_fc_props.information = 'Информация';
_fc_props.cloud_dvir__search_categories = 'Търсене по категории';
_fc_props.cloud_dvir__create_new_category = 'Създаване на нова категория';
_fc_props.category_name = 'Име на категорията';
_fc_props.sub_category = 'Подкатегория';
_fc_props.sub_category_name = 'Име на подкатегорията';
_fc_props.delete_category = 'Изтриване на категория';
_fc_props.cloud_dvir__dvir_information = 'Информация за DVIR';
_fc_props.cloud_dvir__dvir_choose_categories = 'Изберете категории';
_fc_props.cloud_dvir__create_category = 'Създаване на категория';
_fc_props.cloud_dvir__update_category = 'Актуализиране на категорията';
_fc_props.delete_route_point = 'Изтриване на точка от маршрута';
_fc_props.view_route_points = 'Преглед на точките от маршрута';
_fc_props.ignore_cancel_preload = 'Игнорирайте анулирането, предварително сте заредени. Вашият хоумрън ще бъде показан скоро.';
_fc_props.cloud_dvir__assigned_mechanic = 'Назначен механик';
_fc_props.cloud_dvir__add_mechanic = 'Добавете механик';
_fc_props.contact_type = 'Тип контакт';
_fc_props.cloud_dvir__send_email_notifications = 'Изпращане на имейл известия';
_fc_props.menu_dvir_title_admin_dvir = 'ДВИР';
_fc_props.cloud_dvir__error_retrieving_dvir_history = 'Грешка при извличане на записи от историята на DVIR.';
_fc_props.cloud_dvir__error_processing_dvir_record = 'Грешка при извличане на DVIR записа.';
_fc_props.cloud_dvir__error_saving_submission = 'Грешка при запазване на изпращането. Опитайте отново.';
_fc_props.cloud_dvir__error_retrieving_mechanics = 'Грешка при извличане на списъка с механики.';
_fc_props.cloud_dvir__template_saved = 'Шаблонът е запазен';
_fc_props.cloud_dvir__error_retrieving_dvir_templates = 'Грешка при извличане на списъка с шаблони.';
_fc_props.cloud_dvir__error_saving_dvir_template = 'Грешка при запазване на шаблона. Опитайте отново.';
_fc_props.dispatch_group = 'Диспечерска група';
_fc_props.save_adjust = 'Запазване и коригиране на точка от маршрута';
_fc_props.reset_route_point = 'Нулиране на точка от маршрута';
_fc_props.no_records_stub_adjust_filters = 'Опитайте да промените настройките си за търсене или филтриране, за да увеличите броя на резултатите.';
_fc_props.no_dvir_records = 'Всичко е наясно с DVIR-ите!';
_fc_props.no_dvir_records_sub_title = 'Постигнал си много';
_fc_props.settings.master_data_connex_x_api_key = 'Master Data Connex x-api-key';
_fc_props.slump_not_obtained_for_x = 'Не са получени данни за спад за: {0}';
_fc_props.please_select_a_sensor_status_type = 'Моля, изберете типовете състояние на сензорите, за да задействате това предупреждение';
_fc_props.settings.master_data_connex_token = 'Master Data Connex Token';
_fc_props.error_validating_master_data_connex_credentials = 'Грешка при валидирането на идентификационните данни на Master Data Connex';
_fc_props.settings.master_data_connex_base_url = 'URL адрес на базата на главни данни Connex';
_fc_props.settings.master_data_connex_exp_time = 'Време на изтичане на Master Data Connex';
_fc_props.download_template = 'Изтегляне на шаблон';
_fc_props.menu_settings_title_dispatch_group = 'Групи за изпращане';
_fc_props.settings.dispatch_groups = 'Групи за изпращане';
_fc_props.dispatch_group_name = 'Име на групата за изпращане';
_fc_props.dispatch_group_plants = 'Растения на групата за диспечерски услуги';
_fc_props.dispatch_group_plants_mapping_message = 'Посочете кои растения ще бъдат част от тази диспечерска група.';
_fc_props.dispatch_group_users_mapping_message = 'Посочете кои потребители ще бъдат част от тази група за изпращане.';
_fc_props.dispatch_group_plant_disassociation_message = 'Заводът трябва да бъде под една диспечерска група едновременно';
_fc_props.dispatch_group_search_by_plant = 'Търсене по име на растение';
_fc_props.dispatch_group_search_by_username = 'Търсене по потребителско име';
_fc_props.search_by_dispatch_group_name = 'Търсене по име на група за изпращане';
_fc_props.create_dispatch_group = 'Създаване на група за изпращане';
_fc_props.update_dispatch_group = 'Актуализиране на групата за изпращане';
_fc_props.dispatch_group_saved = 'Групата за изпращане е запазена';
_fc_props.warning_deleting_dispatch_group_unassociate_plants = 'Изтриването на тази диспечерска група ще създаде диспечерски групи по подразбиране за свързаните инсталации.';
_fc_props.error_saving_dispatch_group = 'Грешка при запазване на групата за изпращане. Опитайте отново.';
_fc_props.please_enter_a_valid_plant_num = 'Моля, въведете валиден номер на растение.';
_fc_props.cloud_dvir__report_no_defects = 'Няма дефекти';
_fc_props.shoud_select_dispatch_group = 'Трябва да изберете поне една група за изпращане';
_fc_props.one_or_more_users_are_associated_with_this_dispatch_group_only = 'Не може да се изтрие, защото тази група за изпращане съдържа потребители, които са свързани само с тази група за изпращане.';
_fc_props.cloud_dvir__username = 'Потребителско име';
_fc_props.cloud_dvir__password = 'Парола';
_fc_props.cloud_dvir__login = 'Вход';
_fc_props.cloud_dvir__mechanic_sign_in = 'Вход за механик';
_fc_props.delete_dispatch_group = 'Изтриване на група за изпращане';
_fc_props.cloud_dvir__driver = 'Шофьор';
_fc_props.cloud_dvir__equipment_pound = 'Оборудване #';
_fc_props.cloud_dvir__mechanic = 'Механик';
_fc_props.dispatch_group_user_only_unassociate_message = 'Не може да се изтрие потребител, защото потребителите трябва да са свързани с поне една група за изпращане.';
_fc_props.cloud_dvir__time_period_filter_today = 'Днес';
_fc_props.cloud_dvir__time_period_filter_yesterday = 'Вчера';
_fc_props.cloud_dvir__time_period_filter_last_7_days = 'Последните 7 дни';
_fc_props.cloud_dvir__time_period_filter_last_30_days = 'Последните 30 дни';
_fc_props.cloud_dvir__date_range_filter = 'Филтриране по дата';
_fc_props.cloud_dvir__download = 'Изтегляне';
_fc_props.dispatch_group_is_empty = 'Групата за изпращане не може да бъде празна.';
_fc_props.dispatch_group_with_empty_plants = 'Поне едно предприятие трябва да е свързано с диспечерската група.';
_fc_props.dispatch_group_with_empty_users = 'Поне един потребител трябва да е свързан с групата за диспечерски услуги.';
_fc_props.not_delete_one_or_more_users_are_associated_with_this_dispatch_group_only = 'Не може да се изтрие групата за изпращане, тъй като тя съдържа потребители, които са свързани само с тази група за изпращане.';
_fc_props.dispatch_group_not_exists = 'Групата за изпращане не съществува.';
_fc_props.dispatch_group_contains_one_plant = 'Не може да се изтрие, защото тази група за изпращане съдържа само едно растение.';
_fc_props.dispatch_group_users = 'Потребители на групата за изпращане';
_fc_props.cloud_dvir__error_retrieving_dvir = 'Грешка при извличане на DVIR запис';
_fc_props.cloud_dvir__assign_mechanic = 'Назначаване на механик';
_fc_props.cloud_dvir__submit_review = 'Изпращане на отзив';
_fc_props.error_deleting_dispatch_group = 'Грешка при изтриването на групата за изпращане.';
_fc_props.error_retrieving_dispatch_groups = 'Грешка при извличане на списъка с групи за изпращане.';
_fc_props.cloud_dvir__undo_selection = 'Отмяна на избора';
_fc_props.enable_master_data = 'Активиране на основни данни';
_fc_props.manually_sync = 'Ръчно синхронизиране';
_fc_props.master_data_connex_token_expiration = 'Изтичане на срока на валидност на токена Master Data Connex';
_fc_props.cloud_dvir__time_period_filter_custom = 'Персонализирано';
_fc_props.settings.zello_session_timeout_minutes = 'Време за изчакване на сесията в Zello (минути)';
_fc_props.menu_settings_title_master_data = 'Основни данни';
_fc_props.settings.master_data = 'Основни данни';
_fc_props.error_retrieving_master_data = 'Грешка при извличане на основните данни';
_fc_props.master_data_sync_completed = 'Синхронизирането на основните данни е завършено';
_fc_props.master_data_successfully_updated = 'Данните са актуализирани успешно';
_fc_props.master_data_failed_to_update = 'Запазването не бе успешно.';
_fc_props.master_data_sync_initiated = 'Синхронизирането на основните данни е стартирано';
_fc_props.master_data_sync_failed = 'Синхронизирането на основните данни не беше успешно';
_fc_props.enabled_excluding_origin_on_deliveries = 'Вярно (без произхода на билетите за доставка)';
_fc_props.enabled_including_origin_on_deliveries = 'Вярно (включително произхода на билетите за доставка)';
_fc_props.cloud_dvir__i_will_decide_later = 'Ще реша по-късно';
_fc_props.returning = 'Връщане';
_fc_props.leftover_concrete = 'Остатъчен бетон';
_fc_props.leftover_concrete_on_vehicle_x = 'Остатъци от бетон върху превозното средство {0}';
_fc_props.leftover_concrete_alert = 'Предупреждение за остатъци от бетон';
_fc_props.wc_ratio_exceeded = 'Превишено съотношение W/C';
_fc_props.search_by_site_name = 'Търсене по име на сайт';
_fc_props.sites = 'Сайтове';
_fc_props.token_expiration = 'Изтичане на срока на валидност на токена';
_fc_props.menu_settings_title_connex_api_key_management = 'Управление на ключове за API на Connex';
_fc_props.settings.connex_api_key_management = 'Управление на ключове за API на Connex';
_fc_props.error_retrieving_connex_api_key_data = 'Грешка при извличане на ключовите данни на connex api';
_fc_props.qr_code = 'QR код';
_fc_props.informing_driver_and_interface_when_entering_wrong_plant = 'Информиране на водача и интерфейса при влизане в грешен завод';
_fc_props.enable_driver_message = 'Активиране на съобщението на водача';
_fc_props.enable_dispatch_message = 'Активиране на съобщение за изпращане';
_fc_props.enable_sending_message_to_interface = 'Активиране на изпращането на съобщение до интерфейса';
_fc_props.ticket_qr_code = 'QR код';
_fc_props.leftover_concrete_alert_description = 'Предупреждение, когато се открият остатъци от бетон след изливане.';
_fc_props.minimum_leftover_concrete_amount = 'Минимално количество остатъчен бетон';
_fc_props.error_validating_master_data_connex_credentials_unauthorized = 'Грешка при валидиране на главни данни Connex идентификационни данни не са оторизирани';
_fc_props.error_validating_master_data_connex_credentials_permissions = 'Грешка при валидиране на разрешенията за идентификационни данни на Master Data Connex';
_fc_props.error_validating_master_data_connex_url_not_found = 'Грешка при валидиране на URL адреса на главните данни Connex не е намерен';
_fc_props.error_validating_master_data_connex_unknown_error = 'Грешка при валидиране на главни данни Connex Неизвестна грешка';
_fc_props.master_data_sync_failed_sync_up_vehicle_type = 'Синхронизирането на основните данни не е успешно. Синхронизирайте типа на превозното средство.';
_fc_props.master_data_sync_failed_sync_up_vehicle = 'Синхронизирането на основните данни не е успешно. Синхронизирайте превозното средство.';
_fc_props.master_data_sync_failed_sync_up_plant = 'Синхронизирането на основните данни не е успешно. Синхронизирайте инсталацията.';
_fc_props.master_data_sync_failed_data_base_connection = 'Синхронизирането на основните данни не успя да се свърже с базата данни.';
_fc_props.error_validating_master_data_connex_permission_is_insufficient = 'Грешка при валидиране на идентификационни данни на Master Data Connex. Разрешението за токен на носителя е недостатъчно.';
_fc_props.settings.back_date_arrive_job = 'Работа с обратна дата за пристигане';
_fc_props.device_notifications = 'Известия';
_fc_props.loading_number = 'Номер на зареждане';
_fc_props.leftover_concrete_volume_temp_age = 'Остатъчен обем={0}, Температура={1}, Възраст={2}';
_fc_props.total_ordered = 'Общо поръчано количество';
_fc_props.total_ticketed = 'Доставено Поръчано';
_fc_props.load_number = 'Номер на товар';
_fc_props.min_leftover_concrete_must_be_filled_in_and_gt_x = 'Минималното количество остатъчен бетон трябва да се запълни и да е по-голямо от {0}';
_fc_props.error_validating_master_data_connex_credentials_are_the_same = 'Грешка при валидирането на основните данни. Идентификационните данни не могат да бъдат еднакви.';
_fc_props.use_aws_for_talk = 'Използвайте AWS за разговори';
_fc_props.air_readings_not_supported = 'Показанията за въздух не се поддържат';
_fc_props.air_not_supported = 'Въздухът не се поддържа';
_fc_props.mix_not_supported = 'Миксът не се поддържа';
_fc_props.air_default_and_none_not_supported = 'Не може да се избере едновременно „по подразбиране“ и „не се поддържа“!';
_fc_props.notifications_enabled = 'Известията са активирани';
_fc_props.prevent_status_change = 'Предотвратяване на промяна на статуса';
_fc_props.message_to_interface = 'Съобщение до интерфейса';
_fc_props.prevent_wrong_plant = 'Предотвратете грешно растение';
_fc_props.previous_tickets = 'Предишни билети';
_fc_props.audit_ticket_number = 'Номер на билет';
_fc_props.audit_date_created = 'Дата на създаване';
_fc_props.audit_vehicle_number = 'Номер на превозно средство';
_fc_props.cloud_dvir__table_ok = 'Безопасно за работа';
_fc_props.cloud_dvir__table_needs_repair = 'Небезопасно за работа';
_fc_props.missing_air_calibration = 'Няма данни за калибриране на въздуха';
_fc_props.reported_defects = 'Докладвани дефекти';
_fc_props.address_latitude = 'Географска ширина на адреса';
_fc_props.address_longitude = 'Географска дължина на адреса';
_fc_props.routing_latitude = 'Маршрутна географска ширина';
_fc_props.routing_longitude = 'Географска дължина на маршрута';
_fc_props.category_name_must_be_unique = 'Името на категорията трябва да е уникално';
_fc_props.subcategory_name_must_be_unique = 'Името на подкатегорията трябва да е уникално';
_fc_props.menu_settings_tracking_device = 'Устройство за проследяване';
_fc_props.menu_settings_title_tracking_device = 'Устройство за проследяване';
_fc_props.menu_settings_title_personal_device_registration = 'Регистрация на лично устройство';
_fc_props.registration_code = 'Регистрационен код';
_fc_props.creation_date = 'Създаване';
_fc_props.expiration_date = 'Изтичане';
_fc_props.trackitadmin_personal_device_registration = 'Регистрация на лично устройство';
_fc_props.create_registration_code = 'Добавяне на регистрационен код';
_fc_props.remove_registration_code = 'Премахване на регистрационния код';
_fc_props.add_a_registration_code = 'Добавяне на регистрационен код';
_fc_props.select_number_of_registration_codes_to_generate = 'Изберете броя регистрационни кодове, които искате да генерирате.';
_fc_props.registration_code_count = 'Брой регистрационни кодове';
_fc_props.are_you_sure_you_want_to_delete_this_reg_code = 'Сигурни ли сте, че искате да изтриете избрания регистриран код?';
_fc_props.are_you_sure_you_want_to_delete_selected_reg_codes = 'Наистина ли искате да изтриете избраните регистрирани кодове?';
_fc_props.add_personal_device = 'Добавяне на лично устройство';
_fc_props.menu_settings_title_personal_device = 'Лично устройство';
_fc_props.cloud_dvir__approval_critical_alert = 'Превозното средство има критичен дефект. Не може да бъде маркирано като безопасно за експлоатация.';
_fc_props.export_registration_codes = 'Кодове за регистрация на износ';
_fc_props.download_format = 'Формат за изтегляне';
_fc_props.specify_download_format_x = 'Посочете формата за изтегляне, за да експортирате регистрационните кодове на {0}';
_fc_props.personal_device_download = 'Изтегляне';
_fc_props.add_personal_device_input_message = 'Въведете личен идентификатор на устройство по-долу. Срокът на валидност ще бъде автоматично приложен след запазване.';
_fc_props.error_creating_personal_device = 'Грешка при създаването на лично устройство';
_fc_props.device_already_exists = 'Лично устройство вече съществува';
_fc_props.export = 'Експорт';
_fc_props.error_can_not_change_connex_eid = 'Не може да се промени connex eid, тъй като в момента се използва за основни данни.';
_fc_props.remove_personal_device = 'Премахване на лично устройство';
_fc_props.are_you_sure_you_want_to_delete_this_personal_device = 'Сигурни ли сте, че искате да изтриете избраното лично устройство?';
_fc_props.are_you_sure_you_want_to_delete_selected_personal_devices = 'Наистина ли искате да изтриете избраните лични устройства?';
_fc_props.error_deleting_personal_device = 'Грешка при изтриване на лично устройство';
_fc_props.customerid = 'Идентификационен номер на клиента';
_fc_props.customername = 'Име на клиента';
_fc_props.ordernumber = 'Номер на поръчката';
_fc_props.orderdescription = 'Описание на поръчката';
_fc_props.locationid = 'Идентификационен номер на местоположението';
_fc_props.locationdescription = 'Описание на местоположението';
_fc_props.productid = 'Идентификационен номер на продукта';
_fc_props.productdescription = 'Описание на продукта';
_fc_props.vehicleid = 'Идентификационен номер на превозното средство';
_fc_props.vehicledescription = 'Описание на превозното средство';
_fc_props.ticketnumber = 'Номер на билет';
_fc_props.ticketdate = 'Дата/час на билета';
_fc_props.drivername = 'Име на шофьора';
_fc_props.arriveregion = 'Регион на пристигане (ВРЕМЕ)';
_fc_props.leaveregion = 'Напускане на региона (TIME)';
_fc_props.regionduration = 'Продължителност на региона';
_fc_props.menu_reports_title_prevailing_wage = 'Преобладаваща работна заплата';
_fc_props.slump_calibration_x_not_found_for_y = 'Калибрирането на спад "{0}" не е намерено за заявка {1}';
_fc_props.slump_calibration_not_found = 'Калибрирането на слягане не е намерено';
_fc_props.slump_calibration_not_found_description = 'Предупреждение, когато калибрирането на слягане не е намерено';
_fc_props.error_getting_personal_device_list = 'Грешка при получаване на списъка с лични устройства';
_fc_props.batch_summary_date_range_note = '*ЗАБЕЛЕЖКА: Този отчет е ограничен до 3 дни, ако не са приложени филтри. Диапазонът от дати може да достигне до 31 дни, когато се филтрира по оборудване (максимум 10), инсталация (максимум 1), продукт (максимум 1) или задача (максимум 1)';
_fc_props.select_registration_code_expiration_time_days = 'Изберете броя дни до изтичане на регистрационните кодове и след това щракнете върху Запазване.';
_fc_props.add_personal_device_expiration = 'Срок на валидност (в дни)';
_fc_props.cloud_dvir__vehicle_no = 'Номер на превозно средство';
_fc_props.cloud_dvir__trailer_no = 'Номер на ремарке';
_fc_props.cloud_dvir__vehicle = 'Превозно средство';
_fc_props.cloud_dvir__trailer = 'Трейлър';
_fc_props.cloud_dvir__truck_number_label = 'Номер на камион';
_fc_props.cloud_dvir__trailer_number = 'Номер на ремаркето';
_fc_props.cloud_dvir__has_trailer = 'Не шофиране с ремарке';
_fc_props.cloud_dvir__trailer_input_field_prompt = 'Въведете номера на ремаркето си тук';
_fc_props.work_order = 'Работна поръчка';
_fc_props.unable_to_determine_slump = 'Не може да се определи спад';
_fc_props.cloud_dvir__determine_the_overall_condition_of_the_trailer = 'Определете общото състояние на ремаркето';
_fc_props.defaultTrailer = 'Трейлър по подразбиране';
_fc_props.trailer_type_column_billable = 'Фактурируемо';
_fc_props.trailer_type_column_notes = 'Бележки';
_fc_props.trailer_type_column_date = 'Дата';
_fc_props.trailer_type_column_order = 'Поръчка';
_fc_props.trailer_type_column_ticket = 'Билет';
_fc_props.trailer_type_column_project = 'Проект';
_fc_props.trailer_type_column_customer = 'Клиент';
_fc_props.trailer_type_column_location = 'Местоположение';
_fc_props.trailer_type_column_vehicle_type = 'Тип превозно средство';
_fc_props.trailer_type_column_product = 'Продукт';
_fc_props.trailer_type_action_rebill = 'Префактуриране';
_fc_props.master_data_sync_failed_no_default_vehicle_type_has_been_set = 'Синхронизирането на основните данни не е успешно, не е зададен тип оборудване по подразбиране';
_fc_props.trailer_type = 'Тип ремарке';
_fc_props.trailer_type_is_required = 'Посочете тип ремарке';
_fc_props.trailer_number_already_exists = 'Номерът на ремаркето вече съществува';
_fc_props.plate_number_already_exists = 'Регистрационният номер вече съществува';
_fc_props.trailer_vin_already_exists = 'Винификацията на трейлъра вече съществува';
_fc_props.trailer_does_not_exist = 'Трейлърът не съществува';
_fc_props.trailer_number_is_required = 'Номерът на ремаркето е задължителен';
_fc_props.plate_number_is_required = 'Номерът на регистрационната табела е задължителен';
_fc_props.plate_number = 'Номер на регистрационен номер';
_fc_props.menu_settings_title_trailer = 'Трейлър';
_fc_props.add_trailer = 'Добавяне на трейлър';
_fc_props.edit_trailer = 'Редактиране на трейлъра';
_fc_props.menu_settings_title_equipment = 'Оборудване';
_fc_props.settings_ignore_new_tickets_from_command_cloud_older_than_specified_minutes = 'Игнорирайте нови билети от Command Cloud, по-стари от X минути';
_fc_props.settings_ignore_new_tickets_from_command_cloud_older_than_specified_minutes_title = 'Игнориране на нови билети от Command Cloud с дата и час на изпращане, по-стари от X минути (по подразбиране е празно и изключено)';
_fc_props.edit_load_card = 'Редактиране на карта за зареждане';
_fc_props.default_layout = 'Оформление по подразбиране';
_fc_props.load_card_empty_fields = 'Грешка при запазване на зареждането на картата: Трябва да бъдат избрани едно или повече полета.';
_fc_props.trailers = 'Ремаркета';
_fc_props.error_failed_to_save_data = 'Грешка: Запазването на данните не бе успешно';
_fc_props.slump_increased_plasticizer_added_question = 'Колко пластификатор е добавен?';
_fc_props.add_trailer_type = 'Добавяне на тип ремарке';
_fc_props.menu_settings_title_trailer_type = 'Тип ремарке';
_fc_props.edit_trailer_type = 'Редактиране на типа трейлър';
_fc_props.single_use_codes = 'Кодове за еднократна употреба';
_fc_props.multiple_use_codes = 'Кодове за многократна употреба';
_fc_props.trailer_type_description_is_required = 'Описанието на типа ремарке е задължително';
_fc_props.trailer_saved = 'Трейлърът е запазен';
_fc_props.cloud_dvir__trailer_only_dvir = 'Само трейлър DVIR';
_fc_props.choose_file = 'Изберете файл';
_fc_props.no_file_chosen = 'Няма избран файл';
_fc_props.please_choose_file = 'Моля, изберете файл';
_fc_props.no_filters = 'Няма избрани филтри';
_fc_props.remaining_defects = 'Оставащи дефекти';
_fc_props.load_more = 'Зареди още';
_fc_props.pagination_label = '{0}-{1} от {2}';
_fc_props.extend = 'Удължи';
_fc_props.cloud_dvir__notes_or_photo_required = 'Необходими са или бележки, или снимка.';
_fc_props.no_default_plant_specified_failed_to_save = 'Не е посочено растение по подразбиране.';
_fc_props.no_default_employee_type_specified_failed_to_save = 'Не е посочен тип служител по подразбиране.';
_fc_props.personal_device_registration_code_saved = 'Кодът за регистрация на лично устройство е запазен';
_fc_props.error_saving_personal_device_registration_code = 'Грешка при запазване на кода за регистрация на лично устройство. Опитайте отново.';
_fc_props.settings.master_data_sub_title = 'Настройте интеграция на основни данни между TrackIt и Connex';
_fc_props.connex_authentication = '{0} Удостоверяване';
_fc_props.select_company = 'Изберете компания';
_fc_props.requirements = 'Изисквания';
_fc_props.default_plant_type = 'Завод по подразбиране';
_fc_props.default_employee_type = 'Тип служител по подразбиране';
_fc_props.default_equipment_type = 'Тип оборудване по подразбиране';
_fc_props.support_alphanumeric_trucks = 'Поддръжка на буквено-цифрови камиони';
_fc_props.no_default_equipment_type_specified_failed_to_save = 'Не е посочен тип оборудване по подразбиране.';
_fc_props.air_pau_battery_low_message = 'Предупреждение за изтощена батерия на Air PAU';
_fc_props.air_pau_battery_low = 'Ниска батерия на Air PAU';
_fc_props.alert_when_air_pau_battery_low = 'Предупреждение, когато батерията на Air PAU е изтощена';
_fc_props.air_pau_battery_low_alert = 'Предупреждение за ниско ниво на батерията на въздуха';
_fc_props.sensor_unable_to_determine_slump = 'Сензорът не може да определи свлачище';
_fc_props.menu_settings_title_export = 'Експорт';
_fc_props.compare_company = 'Сравнете с друга компания';
_fc_props.site_settings = 'Настройки на сайта';
_fc_props.permission_type = 'Тип разрешение';
_fc_props.ticket_integration = 'Интеграция на билети';
_fc_props.select_one_or_more_settings = 'Моля, изберете една или повече настройки';
_fc_props.export_tooltip = 'Тази опция е налична само ако принадлежите към повече от една компания.';
_fc_props.select_company_error = 'Моля, изберете компания';
_fc_props.audible = 'Звуков';
_fc_props.deleted_master_data_successfully = 'Основните данни са успешно изтрити';
_fc_props.cloud_dvir__units_miles_abbr = 'Мичиган';
_fc_props.cloud_dvir__units_kilometers_abbr = 'км';
_fc_props.create_hauler_order = 'Създаване на поръчка за превозвач';
_fc_props.send_gps = 'Изпращане на GPS';
_fc_props.cloud_dvir__search_results = 'Резултати от търсенето';
_fc_props.cloud_dvir__advanced_filter = 'Разширен филтър';
_fc_props.preload = 'Предварително зареждане';
_fc_props.job_name = 'Име на заданието';
_fc_props.delivery_address = 'Адрес за доставка';
_fc_props.total_water_added = 'Общо добавена вода';
_fc_props.total_customer_water_added = 'Общо добавена вода от клиентите';
_fc_props.concrete_volume = 'Обем на бетона';
_fc_props.water_events_and_volume = 'Водни събития и обем';
_fc_props.menu.reports.title.water_events_and_volume = 'Водни събития и обем';
_fc_props.menu.reports.description = {};
_fc_props.menu.reports.description.water_events_and_volume = 'Вижте добавената вода за билети в различни статуси и групи';
_fc_props.returned_concrete_volume = 'Върнат обем на бетона';
_fc_props.customer_water_added = 'Добавена от клиента вода';
_fc_props.averages_and_totals = 'Средни стойности и общи суми';
_fc_props.preload_loading = 'Предварително зареждане';
_fc_props.preload_loaded = 'Предварително зареждане';
_fc_props.send = 'Изпрати';
_fc_props.deliveries_iframe_url = 'URL адрес на IFrame за доставки';
_fc_props.bulk_ticket_completion = 'Попълване на групови билети';
_fc_props.ticket_type = 'Тип билет';
_fc_props.complete_tickets = 'Пълни билети';
_fc_props.tickets_found = 'Намерен(и) билет(и)';
_fc_props.include_preload = 'Включи предварително зареждане';
_fc_props.exclude_preload = 'Изключване на предварителното зареждане';
_fc_props.selected_tickets = 'Избрани билети';
_fc_props.are_you_sure_you_want_to_complete_selected_tickets = 'Сигурни ли сте, че искате да попълните избраните билети?';
_fc_props.completing_tickets = 'Завършване на билети';
_fc_props.some_tickets_failed_to_complete = 'Някои билети не успяха да бъдат попълнени';
_fc_props.bulk_ticket_complete_failed = 'Завършването на груповия билет не бе успешно';
_fc_props.ticket_management = 'Управление на билети';
_fc_props.invalid_url_for_deliveries = 'Невалиден URL адрес за доставки';
_fc_props.menu_dvir_title_translations = 'Преводи';
_fc_props.cloud_dvir__dvir_translation = 'Превод';
_fc_props.template = 'Шаблон';
_fc_props.menu_dvir_title_admin_translations = 'Преводи';
_fc_props.menu.dvir.description.translations = 'Преглед на DVIR преводите';
_fc_props.cloud_dvir__driver_review = 'Преглед на шофьора';
_fc_props.cloud_dvir__mechanic_review = 'Преглед на механика';
_fc_props.cloud_dvir__driver_approval = 'Одобрение на водача';
_fc_props.cloud_dvir__dvir_event_type = 'Тип събитие DVIR';
_fc_props.cloud_dvir__option_print_signed = 'Печат с подпис';
_fc_props.deliveries_cloud_auth_enabled = 'Използвайте Cloud Auth за доставки';
_fc_props.deliveries_host_name = 'Име на хоста за доставки';
_fc_props.cloud_dvir__option_event_history = 'История на събитията';
_fc_props.ticketed_plant = 'Билетиран завод';
_fc_props.cloud_dvir__all_notes_and_photos_will_be_removed = 'Всички бележки и снимки ще бъдат премахнати';
_fc_props.cloud_dvir__continue = 'Продължи';
_fc_props.cloud_dvir__cancel = 'Отказ';
_fc_props.engine_diagnostic_canbaudrate_1 = 'МОЖЕ 1';
_fc_props.engine_diagnostic_canbaudrate_2 = 'МОЖЕ 2';
_fc_props.attached = 'Прикачен';
_fc_props.cloud_dvir__images = 'Изображения';
_fc_props.settings.ticket_voided_status_change = 'Когато билетът е анулиран, променете статуса на';
_fc_props.ticket_voided_status_change_duplication_error = 'Промяна на статуса на анулиран билет: За всеки цикъл на статуси може да бъде избран само един статус';
_fc_props.cloud_not_sending_events = 'Идентификаторът на облачния обект е зададен, но не изпраща събития към облака';
_fc_props.set_ticket_integration_send_to_event_bus = 'В настройките за интеграция на билети задайте състоянието/местоположението на изпращане към моста на събитието на „true“';
_fc_props.cloud_missing_loading = 'Интеграция в облака със статус „ЗАРЕЖДАНЕ“, който не е зададен в типа статус';
_fc_props.cloud_assign_loading = 'Присвойте значение на статуса LOADING, така че да се случи промяната на статуса на зареждане от облака';
_fc_props.cloud_missing_loaded = 'Интеграция в облака със статус LOADED, който не е зададен в типа статус';
_fc_props.cloud_assign_loaded = 'Присвойте значение на статус LOADED, така че да се осъществи промяна на статуса на зареждане от облака';
_fc_props.employee_no_valid_type = 'Служители без валиден тип служител';
_fc_props.employee_assign_valid_type = 'Проверете дали всички служители имат валиден тип служител';
_fc_props.employee_no_valid_home_plant = 'Служители без валидно назначено домашно растение';
_fc_props.employee_assign_valid_home_plant = 'Проверете дали на всички служители е присвоено домашно растение';
_fc_props.employee_dup_alt_num = 'Служители с дублиран алтернативен служебен номер';
_fc_props.employee_fix_dup_alt_num = 'Проверете дали всички служители имат уникален алтернативен служебен номер';
_fc_props.employee_type_no_default = 'Няма тип служител по подразбиране';
_fc_props.employee_type_assign_default = 'Задаване на тип служител по подразбиране';
_fc_props.equipment_type_no_default = 'Няма тип оборудване по подразбиране';
_fc_props.equipment_type_assign_default = 'Задаване на тип оборудване по подразбиране';
_fc_props.equipment_type_not_used = 'Неразпределени типове оборудване';
_fc_props.equipment_type_assign_not_used = 'Премахнете неизползваните типове оборудване';
_fc_props.equipment_no_valid_type = 'Оборудване без валиден зададен тип оборудване';
_fc_props.equipment_assign_valid_type = 'Проверете дали цялото оборудване е зададено с валиден тип оборудване';
_fc_props.equipment_no_valid_home_plant = 'Оборудване без валидно зададено домашно растение';
_fc_props.equipment_assign_valid_home_plant = 'Проверете дали на цялото оборудване е присвоен домашен завод.';
_fc_props.equipment_no_valid_last_plant = 'Оборудване без валидно присвоено последно предприятие';
_fc_props.equipment_assign_valid_last_plant = 'Проверете дали на цялото оборудване е присвоен последен завод.';
_fc_props.equipment_dup_interface_num = 'Оборудване с дублиращи се номера на интерфейси';
_fc_props.equipment_fix_dup_interface_num = 'Проверете дали цялото оборудване има уникален номер на интерфейс';
_fc_props.equipment_no_vin = 'Оборудване с Cloud DVIR, но без VIN';
_fc_props.equipment_assign_vin = 'Актуализирайте оборудването, за да имате VIN номер';
_fc_props.equipment_probe_no_drum_type = 'Оборудване с лиценз за сонда, но без тип барабан';
_fc_props.equipment_probe_assign_drum_type = 'Актуализирайте оборудването, за да има тип барабан';
_fc_props.equipment_drs_no_drum_type = 'Оборудване със сензор за въртене на барабана, но без тип барабан';
_fc_props.equipment_drs_assign_drum_type = 'Актуализирайте оборудването, за да има тип барабан';
_fc_props.equipment_ed_no_config = 'Оборудване с лиценз за диагностика на двигателя и без конфигурация';
_fc_props.equipment_ed_assign_no_config = 'Актуализирайте оборудването, за да имате конфигурация за диагностика на двигателя';
_fc_props.plant_no_dispatch_group = 'Растения без диспечерска група';
_fc_props.plant_assign_dispatch_group = 'Присвоете растения към съществуващи групи за изпращане или запазете отново растенията, за да присвоите групи за изпращане';
_fc_props.plant_dup_num = 'Растение с дублирани номера на растенията';
_fc_props.plant_fix_dup_num = 'Проверете дали всички растения имат уникални номера';
_fc_props.plant_dup_interface_num = 'Инсталация с дублиращи се номера на интерфейси';
_fc_props.plant_fix_dup_interface_num = 'Проверете дали всички инсталации имат уникален номер на интерфейс';
_fc_props.status_types_no_default_hotspot_type = 'Типове състояния, при които липсва тип гореща точка по подразбиране';
_fc_props.status_types_assign_default_hotspot_type = 'Задаване на тип гореща точка по подразбиране за всеки тип състояние';
_fc_props.hotspot_type_no_valid_enter_status = 'Тип гореща точка: Въведете състояние: вече не съществува';
_fc_props.hotspot_type_assign_valid_enter_status = 'Актуализирайте типа на горещата точка, за да имате валиден статус на въвеждане или никакъв';
_fc_props.hotspot_type_no_valid_exit_status = 'Тип гореща точка, изход, Статусът вече не съществува';
_fc_props.hotspot_type_assign_valid_exit_status = 'Актуализирайте типа на горещата точка, за да имате валиден статус на изход или никакъв';
_fc_props.hotspot_type_not_usable = 'Съществува тип гореща точка за тип състояние, който не е присвоен на нито един тип оборудване';
_fc_props.hotspot_type_fix_not_usable = 'Валидирайте използването на типа „гореща точка“. Ако се създават горещи точки от този тип, те няма да се показват на картата.';
_fc_props.hotspot_invalid_hotspot_type = 'Постоянната гореща точка липсва тип гореща точка';
_fc_props.hotspot_assign_hotspot_type = 'Актуализирайте точката за достъп, за да имате валиден тип точка за достъп';
_fc_props.plant_hotspot_conflict = 'Горещата точка на растението има конфликтно назначение на растението';
_fc_props.plant_hotspot_fix_conflict = 'Заводът, присвоен на завод, е различен от завода, присвоен в заявката за присвояване. Проверете присвояването на завода на горещата точка. Може да се наложи да пресъздадете горещата точка на завода, за да разрешите проблема.';
_fc_props.plant_hotspot_restricted = 'Достъпът до „Завод“ е ограничен за определени билети';
_fc_props.plant_hotspot_fix_restricted = 'Точката за достъп до растения е ограничена за конкретни билети, необходимо е да се пресъздаде точката за достъп до растения, за да се разреши проблемът';
_fc_props.status_type_not_used = 'Типът статус не е присвоен на нито един тип оборудване';
_fc_props.status_type_fix_not_used = 'Препоръчвам изтриване на типа статус, ако не е необходим';
_fc_props.status_type_no_first = 'Липсва тип статус Първо състояние';
_fc_props.status_type_fix_no_first = 'Задайте първи статус на типа статус';
_fc_props.status_type_no_last = 'Липсва тип статус Последен статус';
_fc_props.status_type_fix_no_last = 'Задайте последен статус на типа статус';
_fc_props.question_no_input_format = 'Въпросът липсва във формат за въвеждане';
_fc_props.question_assign_input_format = 'Задайте формат на въпроса';
_fc_props.ticket_no_concrete_product = 'Билет за DRS или сонда и липсваща единица за кубически ярда или кубически метри на продукт';
_fc_props.ticket_fix_no_concrete_product = 'Проверете източника на заявката и потвърдете, че интеграцията изпраща правилната мерна единица.';
_fc_props.ticket_preload_no_status_meaning = 'Предварително заредени билети, но липсващ статус на предварително зареждане Значения';
_fc_props.ticket_preload_assign_status_meaning = 'Значения на състоянието на настройката за предварително заредени билети';
_fc_props.question_setup_no_end_miles = 'Въпросът за настройка е зададен само в началните мили';
_fc_props.question_setup_assign_end_miles = 'Актуализирайте настройката на въпроса, за да включите както начални, така и крайни мили';
_fc_props.question_setup_no_begin_miles = 'Въпросът за настройка е зададен само за крайни мили';
_fc_props.question_setup_no_end_hours = 'Зададени са само начални часове за настройка на въпроси';
_fc_props.question_setup_assign_end_hours = 'Актуализирайте настройката на въпросите, за да включите както началните, така и крайните часове';
_fc_props.question_setup_no_begin_hours = 'Зададени са крайни часове само за настройка на въпроси';
_fc_props.question_setup_no_last_plant = 'Настройката на въпроса не задава последен завод за оборудване';
_fc_props.question_setup_assign_last_plant = 'Актуализирайте настройката на въпроса, за да включите настройката „Последен завод за оборудване“';
_fc_props.device_not_used = 'Активно устройство, което не е използвано през последните 6 месеца';
_fc_props.device_delete_not_used = 'Проверете дали устройствата все още са необходими';
_fc_props.cloud_integration = 'Интеграция в облака';
_fc_props.user_not_used = 'Потребителите на сайта не са влизали в системата повече от 6 месеца';
_fc_props.user_delete_not_used = 'Премахване на потребители, които не влизат';
_fc_props.no_configuration_errors = 'Няма грешки в конфигурацията';
_fc_props.configuration_error_summary = 'Обобщение на конфигурацията';
_fc_props.configuration_errors = 'Конфигурация';
_fc_props.question_setup = 'Настройка на въпроса';
_fc_props.plant_no_default = 'Няма завод по подразбиране';
_fc_props.plant_assign_default = 'Задаване на растение по подразбиране';
_fc_props.master_data_error_logs = 'Регистрационни файлове за грешки в основните данни';
_fc_props.master_data_error_logs_fetch_failed = 'Извличането на регистрационни файлове за грешки в основните данни не беше успешно';
_fc_props.equipment_flow_meter_no_pulse = 'Оборудването има дебитомер, но няма обем на импулс';
_fc_props.equipment_flow_meter_fix_no_pulse = 'Задайте обем на импулс за разходомера на оборудването';
_fc_props.equipment_flow_meter_no_unit = 'Оборудването има разходомер, но не е избрана водна единица';
_fc_props.equipment_flow_meter_fix_no_unit = 'Задайте водна единица за разходомер на оборудването';
_fc_props.warn = 'Предупреждение';
_fc_props.security = 'Сигурност';
_fc_props.error_validating_master_data_entity_not_found = 'Грешка при валидирането на основните данни, обектът не е намерен';
_fc_props.device_message_queue_not_assigned = 'device_message_queue_id или device_message_canary_queue_id не е зададено в database_server за hostname';
_fc_props.device_message_queue_not_assigned_resolution = 'Необходими са валидни device_message_queue_id и device_message_canary_queue_id в database_server';
_fc_props.talk_queue_not_assigned = 'talk_queue_id или talk_canary_queue_id не е зададен в database_server за hostname';
_fc_props.talk_queue_not_assigned_resolution = 'Необходими са валидни talk_queue_id и talk_canary_queue_id в database_server';
_fc_props.device_message_queue_dne = 'device_message_queue_id не съществува за database_server_id';
_fc_props.device_message_queue_dne_resolution = 'Необходим е валиден device_message_queue_id за таблицата database_server';
_fc_props.device_message_canary_queue_dne = 'device_message_canary_queue_id не съществува за database_server_id';
_fc_props.device_message_canary_queue_dne_resolution = 'Необходим е валиден device_message_canary_queue_id за таблицата database_server';
_fc_props.talk_queue_id_dne = 'talk_queue_id не съществува за database_server_id';
_fc_props.talk_queue_id_dne_resolution = 'Необходим е валиден talk_queue_id за таблицата database_server';
_fc_props.talk_canary_queue_id_dne = 'talk_canary_queue_id не съществува за database_server_id';
_fc_props.talk_canary_queue_id_dne_resolution = 'Необходим е валиден talk_canary_queue_id за таблицата database_server';
_fc_props.device_message_queue_no_default = 'device_message_queue липсва по подразбиране';
_fc_props.device_message_queue_no_default_resolution = 'Задайте стойност по подразбиране в device_message_queue';
_fc_props.message_queue_url_dne = 'message_queue_url е null в device_message_queue';
_fc_props.message_queue_url_dne_resolution = 'Необходим е валиден message_queue_url в device_message_queue';
_fc_props.talk_queue_url_dne = 'talk_queue_url е null в device_message_queue';
_fc_props.talk_queue_url_dne_resolution = 'Необходим е валиден talk_queue_url в device_message_queue';
_fc_props.database_server_id_dne = 'database_server_id не съществува за компанията';
_fc_props.database_server_id_dne_resolution = 'Необходим е валиден database_server_id в таблицата database_server';
_fc_props.dbname_assigned_dne = 'dbname е присвоено на потребителите, но компанията не съществува';
_fc_props.dbname_assigned_dne_resolution = 'Премахване от записи от user_bd, където името на базата данни не съществува';
_fc_props.canary_totals = 'Канарски общи суми';
_fc_props.failed_to_find_trackit_environment = 'Неуспешно намиране на TrackItEnvironment';
_fc_props.failed_to_find_trackit_environment_resolution = 'Името на хоста най-вероятно не е картографирано в TrackItEnvironment';
_fc_props.quartz_jobs_not_scheduled = 'Липсващи работни места в Quartz';
_fc_props.quartz_jobs_not_scheduled_resolution = 'Планиране на липсващите задачи';
_fc_props.database_dne_for_company = 'Базата данни не съществува за компанията';
_fc_props.database_dne_for_company_resolution = 'Премахнете компанията от таблицата company, както и от таблицата user_db';
_fc_props.deliveries_not_using_cloud_auth = 'Доставки, които не използват удостоверяване в облака';
_fc_props.deliveries_not_using_cloud_auth_resolution = 'Активирайте облачно удостоверяване за доставки в настройките за интеграция на билети';
_fc_props.talk_using_quartz_scheduler = 'Talk използва кварцов планировчик';
_fc_props.talk_using_quartz_scheduler_resolution = 'Активирайте „Използване на AWS за Talk“ в настройките на сайта';
_fc_props.data_migration_scheduled_and_shouldnt = 'Миграцията на данни е планирана и не трябва да се извършва';
_fc_props.data_migration_scheduled_and_shouldnt_resolution = 'Деактивирайте кварцовото задание за мигриране на данни';
_fc_props.data_migration_not_scheduled = 'Миграцията на данни не е планирана и трябва да бъде';
_fc_props.data_migration_not_scheduled_resolution = 'Активиране на кварцовата задача за мигриране на данни';
_fc_props.data_migration_not_allowed = 'Мигрирането на данни не е разрешено на';
_fc_props.data_migration_allowed_on = 'Мигрирането на данни е разрешено на';
_fc_props.enable_data_migration = 'Активиране на миграция на данни за всяка компания';
_fc_props.disable_data_migration = 'Деактивиране на миграцията на данни за всяка компания';
_fc_props.delayed_jobs_resolution = 'Пресъздаване на тригери, изтриване на тригери или рестартиране на QuartzManager';
_fc_props.environment_setup = 'Обобщение на околната среда';
_fc_props.deprecated = 'Отхвърлено';
_fc_props.quartz_scheduler = 'Кварцов планировчик';
_fc_props.device_queues = 'Опашки на устройствата';
_fc_props.data_migration = 'Миграция на данни';
_fc_props.delayed_jobs = 'Забавени задачи';
_fc_props.hide_find_truck_menu_option = 'Скриване на опцията от менюто „Намери камион“';
_fc_props.configuration_audit_info = 'Информация за одит на конфигурацията';
_fc_props.the_master_data_is_not_enabled_yet = 'Основните данни все още не са активирани';
_fc_props.the_master_data_enablement_audit_info = 'Основните данни са били {0} от потребителя';
_fc_props.on_lower = 'на';
_fc_props.enabled_lower = 'активирано';
_fc_props.disabled_lower = 'инвалид';
_fc_props.mechanic_updated_successfully = 'Механикът е актуализиран успешно.';
_fc_props.no_audit_record = 'Няма наличен одитен запис.';
_fc_props._7_years = '7 години (Архив)';
_fc_props.retention_continue = 'Продължи';
_fc_props.retention_save_confirm_message = 'Това ще повлияе на количеството данни, съхранявани на сървъра, и всички премахнати данни НЕ МОГАТ да бъдат възстановени. Искате ли да продължите?';
_fc_props.cloud_dvir__uom_change_confirmation_title = 'Потвърдете мерните единици и стойностите на километража';
_fc_props.cloud_dvir__uom_change_confirmation = 'Текущата стойност на километража е {{engineValue}} {{engineUom}}, а въведената стойност на километража е {{fromValue}} {{fromUom}}. Правилно ли е това?';

export default _fc_props;
